/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 46);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = self._;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bi = __webpack_require__(39);
var events = __webpack_require__(3);
var errors = __webpack_require__(2);

function importScriptsAsNpmModule(workerGlobalScope, url, appId, scriptName) {
  var scriptScope = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : workerGlobalScope;

  var module = workerGlobalScope.module = {};
  workerGlobalScope.module.exports = {};
  workerGlobalScope.exports = workerGlobalScope.module.exports;
  var oldRequire = workerGlobalScope.require;
  workerGlobalScope.require = function require(mod) {
    if (!workerGlobalScope[mod]) {
      console.error('Failed to require module: ' + mod + ' from url: ' + url); //eslint-disable-line no-console
    }
    return workerGlobalScope[mod];
  };
  var beforeLoad = Date.now();
  try {
    scriptScope.importScripts(url);
    reportBI(events.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
  } catch (err) {
    reportBI(errors.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: err.message
    });
    console.error('Failed to import script: ' + scriptName + ', url: ' + url); //eslint-disable-line no-console
  }
  delete workerGlobalScope.module;
  delete workerGlobalScope.exports;
  workerGlobalScope.require = oldRequire;
  return module.exports;
}

function importScriptsAsAmdModule(workerGlobalScope, url, appId, scriptName) {
  var definedModule = null;
  var oldDefine = workerGlobalScope.define;
  workerGlobalScope.define = function define(deps, mod) {
    definedModule = mod;
  };
  workerGlobalScope.define.amd = true;
  var beforeLoad = Date.now();
  try {
    workerGlobalScope.importScripts(url);
    reportBI(events.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
  } catch (err) {
    var errorMsg = err && err.message;
    reportBI(errors.SCRIPT_LOAD, {
      app_id: appId,
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: errorMsg
    });
    /*eslint-disable no-console*/
    console.error('Failed to import script: ' + scriptName + ', url: ' + url);
    return function () {
      return {};
    };
  }

  if (oldDefine) {
    workerGlobalScope.define = oldDefine;
  } else {
    delete workerGlobalScope.define;
  }

  return definedModule;
}

function sendMessage(message, ports) {
  var args = [message.data || message];

  if (typeof WorkerGlobalScope === 'undefined') {
    args.push('*');
  }
  if (ports) {
    args.push(ports);
  }

  return self.postMessage.apply(self, args);
}

function reportBI(reportDef, params) {
  bi.report(sendMessage, reportDef, params);
}

module.exports = {
  importScriptsAsNpmModule: importScriptsAsNpmModule,
  importScriptsAsAmdModule: importScriptsAsAmdModule,
  reportBI: reportBI,
  sendMessage: sendMessage
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var errors = {
  SCRIPT_LOAD: {
    src: 79,
    eventId: 104,
    params: {
      app_id: 'app_id',
      script_name: 'script_name',
      script_url: 'script_url',
      time_spent: 'time_spent',
      error: 'error'
    }
  },
  INIT_APP_FOR_PAGE: {
    src: 79,
    eventId: 106,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      error: 'error'
    }
  },
  CREATE_CONTROLLERS: {
    src: 79,
    eventId: 108,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      time_spent: 'time_spent',
      error: 'error'
    }
  },
  PAGE_READY: {
    src: 79,
    eventId: 111,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      controller_id: 'controller_id',
      controller_type: 'controller_type',
      error: 'error'
    }
  },
  PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION: {
    errorName: 'PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION',
    errorCode: 111033,
    severity: 'error',
    params: {
      errorMsg: 'errorMsg',
      stack: 'stack',
      line: 'line',
      column: 'column'
    }
  }
};

module.exports = errors;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var events = {
  WORKER_CREATED: {
    src: 79,
    eventId: 101,
    params: {
      worker_id: 'worker_id'
    }
  },
  WORKER_TERMINATED: {
    src: 79,
    eventId: 102,
    params: {
      worker_id: 'worker_id'
    }
  },
  SCRIPT_LOAD: {
    src: 79,
    eventId: 103,
    params: {
      app_id: 'app_id',
      script_url: 'script_url',
      script_name: 'script_name',
      time_spent: 'time_spent'
    }
  },
  INIT_APP_FOR_PAGE: {
    src: 79,
    eventId: 105,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  CREATE_CONTROLLERS: {
    src: 79,
    eventId: 107,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  APP_PAGE_READY: {
    src: 79,
    eventId: 110,
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  },
  ALL_APPS_PAGE_READY: {
    src: 79,
    eventId: 109,
    params: {
      worker_id: 'worker_id',
      time_spent: 'time_spent'
    }
  }
};

module.exports = events;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  BOOTSTRAP: 'wix_code_worker_bootstrap',
  BOOTSTRAP_DONE: 'worker_bootstrap_done',
  LOAD_USER_CODE: 'wix_code_worker_load_user_code',
  LOAD: 'wix_code_worker_load',
  INIT: 'wix_code_worker_init',
  START: 'wix_code_worker_start',
  PAGE_RENDERED: 'trigger_onRender',
  UPDATE_WIX_CODE_DATA_AFTER_LOGIN: 'update_wix_code_model_data_after_login',
  REQUEST_API: 'REQUEST_API',
  PLATFORM_PUBLIC_API_PREFIX: 'viewer_platform_public_api_',
  SCRIPT_IMPORT_MESSAGE: 'script_import_message'
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CHILDREN = 'children';
var REPEATER_TYPE = 'wysiwyg.viewer.components.Repeater';

function getAllCompsUnderRoot(model, rootId) {
  var compsUnderRoot = [rootId];
  for (var i = 0; i < compsUnderRoot.length; i++) {
    var children = _.get(model.components, [compsUnderRoot[i], CHILDREN]) || [];
    compsUnderRoot.push.apply(compsUnderRoot, children);
  }
  compsUnderRoot.shift();

  return compsUnderRoot;
}

function isTemplateComp(model, compId) {
  var getCompParent = function getCompParent(compId) {
    return _.get(model, ['components', compId, 'parent']);
  };
  var isCompRepeater = function isCompRepeater(compId) {
    return _.get(model, ['components', currentParent, 'type']) === REPEATER_TYPE;
  };
  var currentComp = compId;
  var currentParent = getCompParent(currentComp);
  // search for the parent that is also direct child of a repeater, if exist
  while (currentParent && !isCompRepeater(currentParent)) {
    currentComp = currentParent;
    currentParent = getCompParent(currentComp);
  }
  // if the direct child is in the repeater's children array, then its a template component, otherwise its a displayed only component
  return isCompRepeater(currentParent) && _.includes(_.get(model, ['components', currentParent, 'children']), currentComp);
}

module.exports = {
  getAllCompsUnderRoot: getAllCompsUnderRoot,
  isTemplateComp: isTemplateComp
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeaterItemsUtils = __webpack_require__(27);

module.exports = {
  items: {
    getAddedItems: repeaterItemsUtils.getAddedItems,
    getRemovedItems: repeaterItemsUtils.getRemovedItems,
    getTemplateCompsId: repeaterItemsUtils.getTemplateCompIds
  },
  structure: {
    getUniqueDisplayedId: repeaterItemsUtils.getUniqueDisplayedId,
    getOriginalId: repeaterItemsUtils.getOriginalId,
    getItemId: repeaterItemsUtils.getItemId,
    SPLITTED_DATA_TYPES: repeaterItemsUtils.SPLITTED_DATA_TYPES
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function validateProp(script, prop) {
  return script[prop];
}

function validateScripts(scripts, properties) {
  var errorScripts = scripts.filter(function (script) {
    return !properties.every(validateProp.bind(null, script));
  }).map(function (script) {
    return JSON.stringify(script);
  });

  if (errorScripts.length) {
    throw new Error('scripts must contain ' + properties.join(', ') + ': ' + errorScripts);
  }
}

module.exports = {
  validate: validateScripts
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  ES6_RUNTIME_PATH: '/es6runtime.min.js',
  WIX_CODE_RUNTIME_PATH: '/all.min.js',
  DATA_BINDING: 'dataBinding',
  DEFAULT_WIX_CODE_PLATFORM: '//static.parastorage.com/services/wix-code-platform/1.11.0',
  REMOTE_DOM_URL: '//unpkg.parastorage.com/@shimil/remote-dom@5.0.0/dist/remote.min.js',
  SEMI_NATIVE_SDK_URL: 'http://static.parastorage.com/services/semi-native-sdk/1.3.0/lib/wix.min.js',
  LODASH: '//static.parastorage.com/unpkg/lodash@4.17.4/lodash.min.js'
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var scriptMap = {};

function handleScript(_ref) {
  var url = _ref.url,
      script = _ref.script;

  if (!scriptMap[url]) {
    scriptMap[url] = script;
  }
}

function btyesToString(ab) {
  if (typeof TextDecoder !== 'undefined') {
    try {
      var td = new TextDecoder();
      return td.decode(ab);
    } catch (e) {
      // empty
    }
  }
  try {
    //eslint-disable-next-line no-undef
    return String.fromCharCode.apply(null, new Uint8Array(ab));
  } catch (e) {
    // empty
  }
  return null;
}

function importScripts(url) {
  var script = scriptMap[url];
  if (script) {
    delete scriptMap[url];
    var code = btyesToString(script);
    if (code) {
      //eslint-disable-next-line no-eval
      eval.call(null, code);
      return;
    }
  }
  self.importScripts(url);
}

module.exports = {
  handleScript: handleScript,
  importScripts: importScripts
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RemoteModelInterface = __webpack_require__(24);
var linkUtils = __webpack_require__(26);
var widgetUtils = __webpack_require__(38);
var uriUtils = __webpack_require__(32);
var richTextUtils = __webpack_require__(28);
var videoUrlsUtils = __webpack_require__(35);
var repeaterUtils = __webpack_require__(6);
var TypeUtils = __webpack_require__(31);
var backgroundUtils = __webpack_require__(25);
var svgUtils = __webpack_require__(29);
var typeData = __webpack_require__(30);
var componentsHooks = __webpack_require__(21);

module.exports = {
  RemoteModelInterface: RemoteModelInterface,
  linkUtils: linkUtils,
  widgetUtils: widgetUtils,
  uriUtils: uriUtils,
  richTextUtils: richTextUtils,
  videoUrlsUtils: videoUrlsUtils,
  repeaterUtils: repeaterUtils,
  backgroundUtils: backgroundUtils,
  svgUtils: svgUtils,
  componentsHooks: componentsHooks,
  typeUtils: new TypeUtils(typeData)
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  WIX_CODE_INTENT: 'WIX_CODE',
  CONSOLE_MESSAGE: 'console',
  SET_TO_STORAGE: 'setToStorage',
  STORAGE_UPDATE: 'storageWasUpdated'
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function AppsStore() {
    _classCallCheck(this, AppsStore);

    this._apps = {};
    this._appsByApplicationIds = {};
  }

  _createClass(AppsStore, [{
    key: 'get',
    value: function get(id) {
      return this._apps[id] || this._apps[this._appsByApplicationIds[id]];
    }
  }, {
    key: 'set',
    value: function set(id, value) {
      this._apps[id] = value;
      return this;
    }
  }, {
    key: 'mapInnerId',
    value: function mapInnerId(innerId, id) {
      this._appsByApplicationIds[innerId] = id;
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var _this = this;

      return Object.keys(this._apps).map(function (k) {
        return _this._apps[k];
      });
    }
  }]);

  return AppsStore;
}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function UserCodeStore() {
    _classCallCheck(this, UserCodeStore);

    this._userCodeByUrl = {};
  }

  _createClass(UserCodeStore, [{
    key: 'set',
    value: function set(url, userCode) {
      this._userCodeByUrl[url] = userCode;
      return this;
    }
  }, {
    key: 'get',
    value: function get(url) {
      return this._userCodeByUrl[url];
    }
  }, {
    key: 'startUserCode',
    value: function startUserCode(configs, storage) {
      var _this = this;

      return configs.map(function (config) {
        var code = _this._userCodeByUrl[config.url];
        if (!code) {
          throw new Error('the script ' + config.url + ' was not loaded using the "load_user_code" event');
        }
        return code(storage, config.routerData);
      });
    }
  }]);

  return UserCodeStore;
}();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var scriptsValidator = __webpack_require__(7);
var workerUtils = __webpack_require__(1);
var biUtils = __webpack_require__(40);
var events = __webpack_require__(3);
var errors = __webpack_require__(2);
var constants = __webpack_require__(8);
var MessageType = __webpack_require__(4);
var scriptsHandler = __webpack_require__(9);

function importScripts(url, scriptName, onSuccess, onFailure) {
  var beforeLoad = Date.now();
  try {
    scriptsHandler.importScripts(url);
    workerUtils.reportBI(events.SCRIPT_LOAD, {
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad
    });
    if (onSuccess) {
      onSuccess();
    }
  } catch (err) {
    /*eslint-disable no-console*/
    console.error('Failed to import script: ' + scriptName + ', url: ' + url);
    workerUtils.reportBI(errors.SCRIPT_LOAD, {
      script_name: scriptName,
      script_url: url,
      time_spent: Date.now() - beforeLoad,
      error: err.message
    });
    if (onFailure) {
      onFailure(err);
    }
  }
}

function loadSdk(parameters, sdkUrl) {
  var onSuccess = function onSuccess() {
    return self.wix.__INTERNAL__.initEnv(parameters);
  };
  var onFailure = function onFailure(err) {
    throw new Error(err);
  };
  importScripts(sdkUrl, 'wixCode-sdk', onSuccess, onFailure);
}

function loadModules(modules, appsStore) {
  modules.forEach(function (module) {
    var app = workerUtils.importScriptsAsNpmModule(self, module.url, module.id, module.displayName, scriptsHandler);
    appsStore.set(module.id, {
      module: app,
      applicationId: module.applicationId,
      appDefId: module.id,
      controllers: {}
    });
    if (!module.applicationId && module.appInnerId) {
      appsStore.mapInnerId(module.appInnerId, module.id);
    }
  });
}

function handleBootstrap(messageData, appsStore) {
  var bootstrapArgs = messageData.bootstrapArguments;
  var wixCodeScripts = bootstrapArgs.wixCodeScripts,
      metaSiteId = bootstrapArgs.metaSiteId,
      viewerSessionId = bootstrapArgs.viewerSessionId,
      ownerId = bootstrapArgs.ownerId;

  if (!bootstrapArgs.sdkParameters) {
    throw new Error('Could not load user code: `sdkParameters` has an invalid value: ' + bootstrapArgs.sdkParameters);
  }

  self.biSessionModel = biUtils.createBiSession(metaSiteId, viewerSessionId, ownerId);

  var scripts = JSON.parse(decodeURIComponent(bootstrapArgs.applications));
  scriptsValidator.validate(scripts, ['id', 'url']);

  if (scripts.some(function (app) {
    return app.id === constants.DATA_BINDING;
  })) {
    wixCodeScripts.forEach(function (_ref) {
      var url = _ref.url,
          id = _ref.id;

      importScripts(url, id);
    });
  }
  loadSdk(bootstrapArgs.sdkParameters, bootstrapArgs.sdkSource);
  loadModules(scripts, appsStore);
  workerUtils.sendMessage({
    intent: 'WIX_CODE_SSR',
    type: MessageType.BOOTSTRAP_DONE
  });
}

module.exports = {
  handleBootstrap: handleBootstrap
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = __webpack_require__(0);
var workerUtils = __webpack_require__(1);
var events = __webpack_require__(3);
var errors = __webpack_require__(2);

function getControllersData(configs) {
  return Object.keys(configs).map(function (controllerId) {
    var type = configs[controllerId].controllerData.controllerType;
    var config = configs[controllerId].controllerData.settings;
    var connections = configs[controllerId].connections || [];
    return {
      type: type,
      config: config,
      connections: connections,
      $w: self.wix.getSelector(controllerId)
    };
  });
}

function registerControllerEvents(wix, controllerId, configs) {
  //TODO: Add context
  configs[controllerId].controllerBehaviors.forEach(function (item) {
    var fn = wix.__INTERNAL__.getEventHandler(item.behavior.params.callbackId);
    if (fn) {
      wix.emitter.on(controllerId, item.action.name, fn);
    }
  });
}

function getControllersReadyResolver(app) {
  var controllersReady;
  app.controllersReady = new Promise(function (resolve) {
    controllersReady = resolve;
  });
  return controllersReady;
}

function callAppCreateControllers(app, configs, reportError) {
  var controllerIds = Object.keys(configs);
  if (!controllerIds.length) {
    return Promise.resolve([]);
  }
  var controllers = [];
  try {
    controllers = app.module.createControllers(getControllersData(configs));
  } catch (err) {
    reportError()(err);
  }
  var wrappedControllers = controllers.map(function (controller, index) {
    var p = Promise.resolve(controller);
    p.catch(reportError(controllerIds[index]));
    return p;
  });
  return Promise.all(wrappedControllers);
}

function getControllersOnReady(controllers, wix, controllerConfigs, app, workerId) {
  var controllerIds = Object.keys(controllerConfigs);
  app.controllers = controllerIds.reduce(function (acc, controllerId, index) {
    var compId = controllerConfigs[controllerId].compId;
    acc[compId] = controllers[index];
    return acc;
  }, {});
  controllerIds.forEach(function (controllerId) {
    return registerControllerEvents(wix, controllerId, controllerConfigs);
  });
  return controllers.map(function (controller, index) {
    var controllerId = controllerIds[index];
    var $w = wix.getSelector(controllerId);
    var scopedGlobalSdkApis = wix.getScopedGlobalApis(controllerId);
    return {
      controllerId: controllerId,
      dependencies: controllerConfigs[controllerId].dependencies || [],
      onReady: $w.onReady.bind($w, function () {
        if (controller.pageReady) {
          return Promise.resolve(controller.pageReady($w, scopedGlobalSdkApis)).then(function (warmupData) {
            return { controllerId: controllerId, warmupData: warmupData };
          }).catch(function (err) {
            workerUtils.reportBI(errors.PAGE_READY, {
              app_id: app.id,
              worker_id: workerId,
              controller_id: controllerId,
              controller_type: controllerConfigs[controllerId].controllerData.controllerType,
              error: err && err.message
            });
          });
        }
        console.warn('controller.start is deprecated please export controller.pageReady method instead'); // eslint-disable-line no-console
        return controller.start($w);
      })
    };
  });
}

function callControllersReadyInOrder(controllersOnReady) {
  function visit(node) {
    if (node.entered || node.visited) {
      return;
    }
    node.entered = true;
    node.dependencies.forEach(function (controllerId) {
      var dep = _.find(controllersOnReady, { controllerId: controllerId });
      if (dep) {
        visit(dep);
      }
    });
    node.visited = true;
    node.onReady();
  }
  var nextNode = _.find(controllersOnReady, function (node) {
    return !node.visited;
  });
  while (nextNode) {
    visit(nextNode);
    nextNode = _.find(controllersOnReady, function (node) {
      return !node.visited;
    });
  }
}

function handleInit(_ref, _ref2) {
  var apps = _ref.apps;
  var workerId = _ref2.workerId,
      getApp = _ref2.getApp;

  if (!apps) {
    throw new Error('Init message data must include apps property');
  }
  var controllersOnReady = [];
  return Promise.all(Object.keys(apps).map(function (appId) {
    var app = getApp(appId);
    if (!app) {
      console.error('App with the id - ' + appId + ' failed to load'); // eslint-disable-line no-console
      return Promise.resolve();
    }
    var _apps$appId$controlle = apps[appId].controllers,
        controllerConfigs = _apps$appId$controlle === undefined ? {} : _apps$appId$controlle;

    var controllersReady = getControllersReadyResolver(app);
    var beforeInit = void 0;
    return app.ready.then(function () {
      beforeInit = Date.now();
      var reportError = function reportError(controllerId) {
        return function (err) {
          var params = {
            app_id: appId,
            worker_id: workerId,
            error: err && err.message,
            time_spent: Date.now() - beforeInit
          };
          if (controllerId) {
            params.controller_id = controllerId;
          }
          workerUtils.reportBI(errors.CREATE_CONTROLLERS, params);
        };
      };
      return callAppCreateControllers(app, controllerConfigs, reportError);
    }).then(function (controllers) {
      var afterInit = Date.now();
      workerUtils.reportBI(events.CREATE_CONTROLLERS, {
        app_id: appId,
        worker_id: workerId,
        time_spent: afterInit - beforeInit
      });
      controllersReady();
      controllersOnReady.push.apply(controllersOnReady, _toConsumableArray(getControllersOnReady(controllers, self.wix, controllerConfigs, app, workerId)));
    }).catch(controllersReady);
  })).then(function () {
    return callControllersReadyInOrder(controllersOnReady);
  });
}

module.exports = {
  handleInit: handleInit
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var events = __webpack_require__(3);
var errors = __webpack_require__(2);
var utils = __webpack_require__(42);
var workerUtils = __webpack_require__(1);
var scriptsValidator = __webpack_require__(7);
var platformUtilities = __webpack_require__(41);

function setElementoryArguments(args) {
  if (!args.baseUrl || typeof args.baseUrl !== 'string') {
    throw new Error('Load message data must include baseUrl of type string');
  }
  if (!args.queryParameters || typeof args.queryParameters !== 'string') {
    throw new Error('Load message data must include queryParameters of type string');
  }

  if (!self.elementorySupport) {
    self.elementorySupport = {};
  }

  self.elementorySupport.baseUrl = args.baseUrl;
  self.elementorySupport.queryParameters = args.queryParameters;
  self.elementorySupport.options = _.assign({}, self.elementorySupport.options, args.options);
}

function startApplications(apps, routersMap, storageValue, workerId, getApp) {
  return Promise.all(apps.map(function (appDef) {
    var app = getApp(appDef.id);
    app.module.initAppForPage = app.module.initAppForPage || function () {};
    var initAppParam = {
      appInstanceId: appDef.id
    };
    if (appDef.routerData) {
      initAppParam.routerReturnedData = appDef.routerData;
    }
    if (appDef.instance) {
      initAppParam.instance = appDef.instance;
    }
    if (appDef.url) {
      initAppParam.url = appDef.url;
    }
    initAppParam.appRouters = Object.keys(routersMap).map(function (id) {
      return routersMap[id];
    }).filter(function (routerDef) {
      return routerDef.appDefinitionId === appDef.id;
    });

    var appStorage = self.wix.getStorage(appDef.id, storageValue);
    var beforeInit = Date.now();
    try {
      app.ready = Promise.resolve(app.module.initAppForPage(initAppParam, platformUtilities.getApi(routersMap, appStorage)));
    } catch (err) {
      /*eslint-disable no-console*/
      console.error(err);
      app.ready = Promise.reject(new Error(err));
    }
    return app.ready.then(function () {
      var afterInit = Date.now();
      workerUtils.reportBI(events.INIT_APP_FOR_PAGE, {
        app_id: appDef.id,
        worker_id: workerId,
        time_spent: afterInit - beforeInit
      });
      return Promise.resolve();
    }).catch(function (err) {
      var errorMsg = err && err.message;
      workerUtils.reportBI(errors.INIT_APP_FOR_PAGE, {
        app_id: appDef.id,
        worker_id: workerId,
        error: errorMsg
      });
      /*eslint-disable no-console*/
      console.error(errorMsg);
    });
  }));
}

function updateWixCodeDataAfterLogin(messageData) {
  var elementoryArguments = messageData.elementoryArguments;
  if (elementoryArguments) {
    setElementoryArguments(elementoryArguments);
  }
}

function handleLoad(_ref, _ref2) {
  var applications = _ref.applications,
      routersMap = _ref.routersMap,
      wixCode = _ref.wixCode,
      elementoryArguments = _ref.elementoryArguments,
      lightboxContext = _ref.lightboxContext,
      sdkParameters = _ref.sdkParameters,
      storage = _ref.storage;
  var workerId = _ref2.workerId,
      getApp = _ref2.getApp,
      userCodeStore = _ref2.userCodeStore;

  if (!Array.isArray(applications)) {
    throw new Error('Load message data must include applications property of type Array');
  }
  if (!routersMap) {
    throw new Error('Load message data must include routersMap of type object');
  }
  if (wixCode && wixCode[0] && wixCode[0].routerData) {
    self.routerData = wixCode[0].routerData;
  }
  scriptsValidator.validate(wixCode, ['id', 'url', 'scriptName', 'displayName']);

  if (elementoryArguments) {
    setElementoryArguments(elementoryArguments);
  }

  var minimalRoutersMap = _.mapValues(routersMap, function (value) {
    return { prefix: value.prefix, pages: value.pages };
  });
  self.wix.__INTERNAL__.setLightboxContext(lightboxContext);
  self.wix.__INTERNAL__.addEnvParams(_.assign({}, sdkParameters, { routersMap: minimalRoutersMap }));
  self.wix.__INTERNAL__.setContextId(workerId);

  if (wixCode) {
    var modules = userCodeStore.startUserCode(wixCode, storage);
    var mergedUserExports = utils.assign.apply(utils, [{}].concat(modules));
    self.wix.__INTERNAL__.setStaticEventHandlers(mergedUserExports, workerId);
  }

  return startApplications(applications, routersMap, storage, workerId, getApp);
}

module.exports = {
  handleLoad: handleLoad,
  updateWixCodeDataAfterLogin: updateWixCodeDataAfterLogin
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var workerUtils = __webpack_require__(1);
var scriptsValidator = __webpack_require__(7);
var scriptRunner = __webpack_require__(44);

function getEmptyModule() {
  return {};
}

function loadScripts(scripts, userCodeStore) {
  var _this = this;

  var appId = 'wixCode';
  var devConsole = console; // eslint-disable-line no-console
  scripts.filter(function (script) {
    return !userCodeStore.get(script.url);
  }).forEach(function (script) {
    try {
      var moduleFunc = workerUtils.importScriptsAsAmdModule(self, script.url, appId, script.displayName);
      userCodeStore.set(script.url, scriptRunner.runScript.bind(_this, devConsole, appId, script, moduleFunc));
    } catch (e) {
      devConsole.error('There was an error in your script');
      devConsole.error(e);
      userCodeStore.set(script.url, getEmptyModule);
    }
  });
}

function handleLoadUserCode() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      wixCode = _ref2.wixCode;

  var _ref = arguments[1];
  var userCodeStore = _ref.userCodeStore;

  if (wixCode && wixCode[0] && wixCode[0].routerData) {
    self.routerData = wixCode[0].routerData;
  }
  scriptsValidator.validate(wixCode, ['id', 'url', 'scriptName', 'displayName']);

  loadScripts(wixCode, userCodeStore);
}

module.exports = {
  handleLoadUserCode: handleLoadUserCode
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function handle() {
  self.wix.__INTERNAL__.triggerOnRender();
}

module.exports = {
  handle: handle
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var platformUtils = __webpack_require__(10);
var workerUtils = __webpack_require__(1);
var events = __webpack_require__(3);
var MessageType = __webpack_require__(4);
var wixCodeMessageType = __webpack_require__(11);
var pmrpc = __webpack_require__(45);

function createRemoteModelInterface(context, apps) {
  var RMI = new platformUtils.RemoteModelInterface(context);
  apps.forEach(function (app) {
    Object.keys(app.controllers).forEach(function (controllerId) {
      RMI.setPublicAPI(controllerId, app.controllers[controllerId].exports);
    });
  });

  return RMI;
}

function initSdk(messageData, RMI) {
  self.wix.__INTERNAL__.initModel({ RMI: RMI, richTextUtils: platformUtils.richTextUtils, uriUtils: platformUtils.uriUtils, svgUtils: platformUtils.svgUtils, linkUtils: platformUtils.linkUtils, backgroundUtils: platformUtils.backgroundUtils, repeaterUtils: platformUtils.repeaterUtils, videoUrlsUtils: platformUtils.videoUrlsUtils, typeUtils: platformUtils.typeUtils, widgetUtils: platformUtils.widgetUtils, componentsHooks: platformUtils.componentsHooks }, messageData.siteInfo, messageData.id);
  self.$w = self.wix.getSelector(messageData.id);
  self.ga = self.wix.ga;
}

function exposePublicAPI() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$module = _ref.module,
      appModule = _ref$module === undefined ? {} : _ref$module,
      appDefId = _ref.appDefId;

  var workerId = arguments[1];

  if (appModule.exports) {
    pmrpc.api.set('' + MessageType.PLATFORM_PUBLIC_API_PREFIX + appDefId + '_' + workerId, appModule.exports);
    workerUtils.sendMessage({
      type: MessageType.REQUEST_API,
      intent: wixCodeMessageType.WIX_CODE_INTENT,
      appDefId: appDefId,
      workerId: workerId
    });
  }
}

function handleStart(messageData, _ref2) {
  var workerId = _ref2.workerId,
      getAllApps = _ref2.getAllApps;

  if (!messageData.id) {
    throw new Error('Could not init sdk: `context.id` is missing');
  }
  if (!messageData.context) {
    throw new Error('Could not init sdk: `context.context` is missing');
  }

  var beforePageReady = Date.now();
  var allApps = getAllApps();
  allApps.forEach(function (app) {
    return exposePublicAPI(app, workerId);
  });
  var allReady = allApps.map(function (app) {
    var beforeStart = Date.now();
    app.controllersReady = app.controllersReady && app.controllersReady.then(function () {
      workerUtils.reportBI(events.APP_PAGE_READY, {
        app_id: app.id,
        worker_id: workerId,
        time_spent: Date.now() - beforeStart
      });
      return Promise.resolve();
    });
    return Promise.resolve(app.controllersReady);
  });

  return Promise.all(allReady).then(function () {
    workerUtils.reportBI(events.ALL_APPS_PAGE_READY, {
      worker_id: workerId,
      time_spent: Date.now() - beforePageReady
    });
    var RMI = createRemoteModelInterface(messageData.context, getAllApps());
    initSdk(messageData, RMI);
    self.wix.__INTERNAL__.triggerOnReady(function () {
      workerUtils.sendMessage({
        intent: 'WIX_CODE',
        type: 'widget_ready',
        widgetId: messageData.id
      });
    });
  });
}

module.exports = {
  handleStart: handleStart
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var wixCodeLogLevel = __webpack_require__(43);
var wixCodeMessageTypes = __webpack_require__(11);

var consoleMethodsToWrap = {
  info: wixCodeLogLevel.INFO,
  warn: wixCodeLogLevel.WARN,
  error: wixCodeLogLevel.ERROR,
  log: wixCodeLogLevel.LOG
};

function _toArray(args) {
  return Array.prototype.map.call(args, function (v) {
    if (v instanceof Error) {
      return v.toString();
    }
    var vt = typeof v === 'undefined' ? 'undefined' : _typeof(v);
    if (vt === 'string' || vt === 'boolean' || vt === 'number' || v === null || v === undefined) {
      return v;
    }
    if (Array.isArray(v)) {
      return _toArray(v);
    }
    if (vt === 'function') {
      return v.toString();
    }
    try {
      return JSON.stringify(v);
    } catch (e) {
      return v.toString();
    }
  });
}

function _createLogMessage(level, args) {
  return {
    intent: wixCodeMessageTypes.WIX_CODE_INTENT,
    type: wixCodeMessageTypes.CONSOLE_MESSAGE,
    data: {
      logLevel: level,
      args: args
    }
  };
}

function _wrapConsoleMethod(consoleInstance, method, sendCallback) {
  var original = consoleInstance[method];

  return function wrapper() {

    sendCallback(_createLogMessage(consoleMethodsToWrap[method], _toArray(arguments)));
    original.apply(consoleInstance, arguments);
  };
}

function wrapConsole(consoleInstance, sendCallback) {
  for (var method in consoleMethodsToWrap) {
    if (consoleMethodsToWrap.hasOwnProperty(method) && consoleInstance.hasOwnProperty(method)) {
      consoleInstance[method] = _wrapConsoleMethod(consoleInstance, method, sendCallback);
    }
  }
  return consoleInstance;
}

function createErrorLogMessage() {
  //all arguments sent to this function will be used as arguments in the created message
  return _createLogMessage(wixCodeLogLevel.ERROR, _toArray(arguments));
}

module.exports = {
  wrapConsole: wrapConsole,
  createErrorLogMessage: createErrorLogMessage
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var repeaterHooks = __webpack_require__(22);

module.exports = {
  repeaters: repeaterHooks
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var repeaterUtils = __webpack_require__(6);
var modelUtils = __webpack_require__(5);

function cloneConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);
  _.forEach(contexts, function (context) {

    var roles = _.keys(_.get(connections, context));
    _.forEach(roles, function (role) {

      var compIds = _.keys(_.get(connections, [context, role]));
      _.forEach(compIds, function (compId) {
        if (_.includes(templateCompIds, compId)) {
          var templateConfig = _.get(connections, [context, role, compId]);

          _.forEach(itemIds, function (itemId) {
            var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(compId, itemId);
            _.set(connections, [context, role, displayedItemId], _.cloneDeep(templateConfig));
          });
        }
      });
    });
  });
}

function updateCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      model['componentsScopes'][displayedItemId] = null;
    });
  });
}

function cloneComponents(model, templateCompIds, itemIds, repeaterId) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var newDisplayedCompId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      var templateData = model.components[templateCompId];
      var newDisplayedCompData = _.cloneDeep(templateData);
      newDisplayedCompData.displayedOnlyComponents = [];
      newDisplayedCompData.children = _.map(templateData.children, function (childId) {
        return repeaterUtils.structure.getUniqueDisplayedId(childId, itemId);
      });
      newDisplayedCompData.parent = templateData.parent === repeaterId ? repeaterId : repeaterUtils.structure.getUniqueDisplayedId(templateData.parent, itemId);
      newDisplayedCompData.displayedRoot = repeaterId;
      newDisplayedCompData.isDisplayed = !!_.get(model.components[repeaterId], 'isDisplayed');
      /*change data-item id for refs*/
      _.forEach(repeaterUtils.structure.SPLITTED_DATA_TYPES, function (dataType) {
        var compDataTypeValue = newDisplayedCompData[dataType];
        if (compDataTypeValue.id) {
          compDataTypeValue.id = repeaterUtils.structure.getUniqueDisplayedId(newDisplayedCompData[dataType].id, itemId);
          _.forEach(compDataTypeValue, function (val, key) {
            if (_.isObject(val) && val.id) {
              compDataTypeValue[key].id = repeaterUtils.structure.getUniqueDisplayedId(compDataTypeValue[key].id, itemId);
            }
          });
        }
      });

      model.components[newDisplayedCompId] = newDisplayedCompData;
    });
  });
}

function cloneComponentsAndConnections(model, templateCompIds, itemIds, repeaterId) {
  cloneConnections(model, templateCompIds, itemIds);
  cloneComponents(model, templateCompIds, itemIds, repeaterId);
  updateCompsScope(model, templateCompIds, itemIds);
}

function removeConnections(model, templateCompIds, itemIds) {
  var connections = _.get(model, 'connections');
  var contexts = _.keys(connections);

  _.forEach(contexts, function (context) {
    var roles = _.keys(_.get(connections, [context]));

    _.forEach(roles, function (role) {
      var compIds = _.keys(_.get(connections, [context, role]));

      _.forEach(compIds, function (compId) {
        var compItemId = repeaterUtils.structure.getItemId(compId);
        var compOriginalId = repeaterUtils.structure.getOriginalId(compId);

        if (compItemId && _.includes(itemIds, compItemId) && _.includes(templateCompIds, compOriginalId)) {
          delete connections[context][role][compId];
        }
      });
    });
  });
}

function removeCompsScope(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.componentsScopes[displayedItemId];
    });
  });
}

function removeComponents(model, templateCompIds, itemIds) {
  _.forEach(templateCompIds, function (templateCompId) {
    _.forEach(itemIds, function (itemId) {
      var displayedItemId = repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      delete model.components[displayedItemId];
    });
  });
}

function removeComponentsAndConnections(model, templateCompIds, itemIds) {
  removeConnections(model, templateCompIds, itemIds);
  removeCompsScope(model, templateCompIds, itemIds);
  removeComponents(model, templateCompIds, itemIds);
}

/*on repeater set items - creates displayed components and connections for added items and removes components and connections that are no loger in items*/
function updateRepeaterItems(RMI, hookName, repeaterId, partial) {
  if (partial.items) {
    var templateCompIds = modelUtils.getAllCompsUnderRoot(RMI._model, repeaterId);
    var repeaterData = _.get(RMI._model.components, [repeaterId, 'data']);
    var addedItems = repeaterUtils.items.getAddedItems(repeaterData.items, partial.items);
    cloneComponentsAndConnections(RMI._model, templateCompIds, _.map(addedItems, 'item._id'), repeaterId);

    var removedItems = repeaterUtils.items.getRemovedItems(repeaterData.items, partial.items);
    removeComponentsAndConnections(RMI._model, templateCompIds, _.map(removedItems, 'item._id'));
    _.forEach(templateCompIds, function (templateCompId) {
      var templateCompData = RMI._model.components[templateCompId];
      templateCompData.displayedOnlyComponents = _.map(partial.items, function (itemId) {
        return repeaterUtils.structure.getUniqueDisplayedId(templateCompId, itemId);
      });
    });
  }
}

/*Hook triggered on each set and check if the set is for template sync all existing item instances*/
function syncRepeaterItemData(RMI, hookName, compId) {
  var _arguments = arguments;

  var model = RMI._model;
  // set comp property to the template comp, since its isDisplayed property is always false
  if (hookName !== 'registerEvent' && modelUtils.isTemplateComp(model, compId)) {
    var comp = _.get(model, ['components', compId]);
    var partial = arguments[3];
    model.components[compId][hookName] = _.defaults({}, partial, comp[hookName]);
  }

  var displayedOnlyComponents = _.get(RMI._model.components, [compId, 'displayedOnlyComponents']);
  if (!_.isEmpty(displayedOnlyComponents)) {
    //is repeater template with displayed only comps
    var funcName = 'set' + _.startCase(hookName);
    if (hookName === 'registerEvent') {
      funcName = 'registerEvent';
      _.forEach(displayedOnlyComponents, function (itemId) {
        var args = [].concat(Array.prototype.slice.call(_arguments));
        RMI[funcName].apply(RMI, [args[3], itemId].concat(args.splice(4)));
      });
      return;
    }
    _.forEach(displayedOnlyComponents, function (itemId) {
      var args = [].concat(Array.prototype.slice.call(_arguments));
      if (hookName === 'data' && !_.isFunction(_.last(args))) {
        //if there is no callback should call setDataWithoutUpdate and not setData
        RMI.setDataWithoutUpdate.apply(RMI, [itemId].concat(args.splice(3)));
        return;
      }
      RMI[funcName].apply(RMI, [itemId].concat(args.splice(3)));
    });
  }
}

module.exports = {
  updateRepeaterItems: updateRepeaterItems,
  syncRepeaterItemData: syncRepeaterItemData
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var _ = __webpack_require__(0);

var HOOKS = {
  all: 'all',
  data: 'data'
};

var ALL_COMPS_TYPE = '*';

var HooksManager = function () {
  function HooksManager() {
    _classCallCheck(this, HooksManager);

    this._hooks = {};
  }

  /**
   * Validate that the hook name is correct
   * @param {String} hookName - hooks name
   */

  _createClass(HooksManager, [{
    key: 'validateHookName',
    value: function validateHookName(hookName) {
      if (!HOOKS[hookName]) {
        throw "Invalid Hook Name " + hookName;
      }
    }

    /**
     * Unregister all hooks.
     */

  }, {
    key: 'unregisterAllHooks',
    value: function unregisterAllHooks() {
      this._hooks = {};
    }

    /**
     * Unregister only hooks that are passed
     * @param {Array} hooksToRemove - array of hooks names
     */

  }, {
    key: 'unregisterHooks',
    value: function unregisterHooks(hooksToRemove) {
      var _this = this;

      _.forEach(hooksToRemove, function (hookName) {
        return delete _this._hooks[hookName];
      });
    }

    /**
     * Execute all callbacks of the specified hook for the specified component. if registered to all will trigger this as well
     * @param {String} RMI
     * @param {String} hookName The name of the hook to execute (i.e HOOKS.DATA).
     * @param {String} compType The component type or none to  hooks that were registered for all component types.
     * @param {String} compId
     * @param {Array?} args The arguments that will be passed to the hook callbacks.
     */

  }, {
    key: 'executeHooksAndUpdateValue',
    value: function executeHooksAndUpdateValue(RMI, hookName, compType, compId, args) {
      function executeTypeHook(hooks) {
        var _this2 = this;

        if (!hooks) {
          return;
        }
        var hooksForCompType = hooks[compType] || [];
        var hooksForAllCompType = hooks['*'] || [];
        _.forEach(hooksForCompType.concat(hooksForAllCompType), function (cb) {
          cb.apply(_this2, [RMI, hookName, compId].concat(args || []));
        });
      }

      var hook = this._hooks[hookName];
      var allPropsHooks = this._hooks[HOOKS.all];
      executeTypeHook(hook);
      executeTypeHook(allPropsHooks);
    }

    /**
     * Register callback to run the function specified in when executing the hook specified in the hookName parameter according to the hook name
     * @param {String} hookName The name of the hook to registered
     * Hook name can be specific prop or all for all props
     * @param {String?} compType The component type that will use the callback while running the operation according to the hookType. if no comp
     * will fire for all comps for the hooks name.
     * @param {function} callback function to execute.
      */

  }, {
    key: 'registerHook',
    value: function registerHook(hookName, compType, callback) {
      this.validateHookName(hookName);
      if (!callback) {
        return;
      }

      var hook = this._hooks[hookName];
      if (!hook) {
        this._hooks[hookName] = hook = {};
      }

      compType = compType || ALL_COMPS_TYPE;
      var hookForComp = hook[compType];
      if (!hookForComp) {
        hook[compType] = hookForComp = [];
      }

      hookForComp.push(callback);
    }
  }, {
    key: 'HOOKS',
    get: function get() {
      return HOOKS;
    }
  }]);

  return HooksManager;
}();

module.exports = HooksManager;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var _ = __webpack_require__(0);
var repeaterUtils = __webpack_require__(6);
var modelUtils = __webpack_require__(5);
var HooksManager = __webpack_require__(23);

var DATA = 'data',
    FULL_DATA = 'fullData',
    DESIGN = 'design',
    STATE = 'state',
    TYPE = 'type',
    PROPS = 'props',
    PARENT = 'parent',
    EVENTS = 'events',
    LAYOUT = 'layout',
    BEHAVIOR = 'behavior',
    PUBLIC_API = 'publicAPI',
    IS_DISPLAYED = 'isDisplayed',
    STYLE = 'style',
    ID = 'id',
    CHILDREN = 'children',
    DISPLAYED_ONLY_COMPONENTS = 'displayedOnlyComponents',
    DISPLAYED_ROOT = 'displayedRoot';

var GLOBAL_SCOPE = 'GLOBAL_SCOPE';
var COMPONENT_SCOPE = 'COMPONENT_SCOPE';

function RemoteModelInterface(modelJson, onUpdateCallback, options) {
  this._model = modelJson || {
    components: {},
    connections: {},
    componentsScopes: {},
    navigation: {},
    siteStructure: {},
    eventHandlers: {},
    EventTypes: {},
    sessionInfo: {},
    appsData: {},
    siteMemberData: { uid: null, permissions: null, onUserLogin: [] },
    scopesHierarchy: [{ type: GLOBAL_SCOPE, id: GLOBAL_SCOPE, additionalData: {} }]
  };
  this._onUpdateCallback = onUpdateCallback;

  var optionsHookManager = _.get(options, '_hooksManager');
  var optionsTransaction = _.get(options, '_transaction');
  this._hooksManager = optionsHookManager ? optionsHookManager : new HooksManager();
  this._transaction = optionsTransaction ? optionsTransaction : { _onTransaction: false, _transactionData: {} };
}

function getCurrentScopeId(onlyNested) {
  return onlyNested ? _.get(this._model.scopesHierarchy, '0.id') : _.map(this._model.scopesHierarchy, function (scopeHierarchy) {
    return _.get(scopeHierarchy, 'id');
  });
}

function generateDefaultCompStructure() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, PARENT, null), _defineProperty(_ref, STATE, {}), _defineProperty(_ref, TYPE, null), _defineProperty(_ref, DATA, {}), _defineProperty(_ref, FULL_DATA, {}), _defineProperty(_ref, DESIGN, {}), _defineProperty(_ref, PROPS, {}), _defineProperty(_ref, LAYOUT, {}), _defineProperty(_ref, EVENTS, []), _defineProperty(_ref, IS_DISPLAYED, false), _defineProperty(_ref, ID, null), _defineProperty(_ref, PUBLIC_API, {}), _defineProperty(_ref, STYLE, {}), _defineProperty(_ref, CHILDREN, []), _defineProperty(_ref, DISPLAYED_ONLY_COMPONENTS, []), _defineProperty(_ref, DISPLAYED_ROOT, null), _ref;
};

RemoteModelInterface.prototype.addComponent = function (compId, compDescriptor) {
  var comp = generateDefaultCompStructure();
  for (var key in comp) {
    comp[key] = compDescriptor[key] || comp[key];
  }
  comp[PARENT] = compDescriptor[PARENT];
  comp[TYPE] = compDescriptor[TYPE];
  comp[ID] = compDescriptor[ID];
  comp[DISPLAYED_ROOT] = compDescriptor[DISPLAYED_ROOT];
  this._model.components[compId] = comp;
  this._model.componentsScopes[compId] = GLOBAL_SCOPE;
};

RemoteModelInterface.prototype.addNavigation = function (navigationData) {
  this._model.navigation = navigationData;
};

RemoteModelInterface.prototype.addSiteStructure = function (siteStructureData) {
  this._model.siteStructure = siteStructureData;
};

RemoteModelInterface.prototype.addConnections = function (connectionsModel) {
  this._model.connections = connectionsModel;
};

RemoteModelInterface.prototype.resetComponentsScope = function () {
  var _this = this;

  for (var compId in this._model.components) {
    var displayedOnlyCompIds = this._model.components[compId].displayedOnlyComponents;

    displayedOnlyCompIds.forEach(function (displayedOnlyCompId) {
      return _this._model.componentsScopes[displayedOnlyCompId] = null;
    });
  }
};

RemoteModelInterface.prototype.addEventTypes = function (EventTypes) {
  this._model.EventTypes = EventTypes;
};

RemoteModelInterface.prototype.addSiteMemberData = function (siteMemberData) {
  var shouldTriggerOnLoginCallback = siteMemberData.uid && siteMemberData.uid !== this._model.siteMemberData.uid;
  _.assign(this._model.siteMemberData, siteMemberData);
  if (shouldTriggerOnLoginCallback) {
    var onUserLoginCallbacks = this._model.siteMemberData.onUserLogin;
    _.forEach(onUserLoginCallbacks, function (callback) {
      callback(siteMemberData);
    });
  }
};

RemoteModelInterface.prototype.addAppsData = function (appsData) {
  this._model.appsData = appsData;
};

RemoteModelInterface.prototype.getAppsData = function () {
  return _.cloneDeep(this._model.appsData);
};

RemoteModelInterface.prototype.getAppData = function (appDefinitionId) {
  return _.cloneDeep(_.get(this._model.appsData, appDefinitionId));
};

RemoteModelInterface.prototype.addOnUserLoginCallback = function (callback) {
  this._model.siteMemberData.onUserLogin.push(callback);
};

RemoteModelInterface.prototype.addSessionInfoProp = function (addSessionInfoProp) {
  _.assign(this._model.sessionInfo, addSessionInfoProp);
};

//Getters

RemoteModelInterface.prototype.getComp = function (compId) {
  return _.cloneDeep(_.get(this._model.components, compId));
};

RemoteModelInterface.prototype.getState = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, STATE]));
};

RemoteModelInterface.prototype.getData = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, DATA]));
};

RemoteModelInterface.prototype.getStyle = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, STYLE]));
};

RemoteModelInterface.prototype.getDesign = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, DESIGN]));
};

RemoteModelInterface.prototype.getType = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, TYPE]));
};

RemoteModelInterface.prototype.getProps = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, PROPS]));
};

RemoteModelInterface.prototype.getEvents = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, EVENTS]));
};

RemoteModelInterface.prototype.getLayout = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, LAYOUT]));
};

RemoteModelInterface.prototype.getId = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, ID]));
};

RemoteModelInterface.prototype.getEventTypes = function () {
  return _.cloneDeep(this._model.EventTypes);
};

RemoteModelInterface.prototype.getPublicAPI = function (compId) {
  var publicApi = _.get(this._model.components, [compId, PUBLIC_API]);
  if (_.isFunction(publicApi)) {
    return publicApi;
  }
  return _.cloneDeep(publicApi);
};

RemoteModelInterface.prototype.getCallbackById = function (callbackId, newFormat) {
  var eventHandler = this._model.eventHandlers[callbackId]; // TODO - backward compatibility - remove after SDK next release
  if (newFormat) {
    return eventHandler;
  }
  return _.get(eventHandler, 'callback');
};

RemoteModelInterface.prototype.getParent = function (compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, PARENT]));
};

RemoteModelInterface.prototype.getChildren = function (parentId) {
  return _.clone(_.get(this._model.components, [parentId, CHILDREN]));
};

RemoteModelInterface.prototype.getSiteStructure = function () {
  return _.cloneDeep(this._model.siteStructure);
};

RemoteModelInterface.prototype.getNavigationInfo = function () {
  return _.cloneDeep(this._model.navigation);
};

RemoteModelInterface.prototype.getFullDataWithOverrides = function (compId) {
  return _.defaults(this.getData(compId), getFullData.call(this, compId));
};

RemoteModelInterface.prototype.getSiteMemberData = function (controllerDataId) {
  var siteMemberData = _.cloneDeep(this._model.siteMemberData);
  if (controllerDataId) {
    var controllerId = _.findKey(this._model.components, ['data.id', controllerDataId]);
    var controllerData = this.getData(controllerId);
    var appDefinitionId = _.get(controllerData, 'applicationId');
    var appData = _.get(this._model.appsData, appDefinitionId);
    if (appData) {
      _.assign(siteMemberData, _.pick(appData, ['instance', 'instanceId']));
    }
  }
  return siteMemberData;
};

RemoteModelInterface.prototype.getSessionInfo = function () {
  return _.cloneDeep(this._model.sessionInfo);
};

//Setters

RemoteModelInterface.prototype.setDataWithoutUpdate = function (compId, partialData) {
  set.call(this, compId, DATA, partialData);
};

RemoteModelInterface.prototype.setData = function (compId, partialData) {
  set.call(this, compId, DATA, partialData, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setStyle = function (compId, partialData, cb) {
  set.call(this, compId, STYLE, partialData, function (cid, property, partial) {
    this._onUpdateCallback.call(this, cid, property, partial, cb);
  }.bind(this));
};

RemoteModelInterface.prototype.setDesign = function (compId, partialData) {
  set.call(this, compId, DESIGN, partialData, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setProps = function (compId, partialProps, cb) {
  set.call(this, compId, PROPS, partialProps, function (cid, property, partial) {
    this._onUpdateCallback.call(this, cid, property, partial, cb);
  }.bind(this));
};

RemoteModelInterface.prototype.setLayout = function (compId, partialLayout) {
  set.call(this, compId, LAYOUT, partialLayout, this._onUpdateCallback);
};

RemoteModelInterface.prototype.setPublicAPI = function (compId, api) {
  var comp = _.get(this._model.components, compId);
  if (comp) {
    comp[PUBLIC_API] = api;
  }
};

RemoteModelInterface.prototype.getCurrentScope = function () {
  return _.clone(_.get(this._model.scopesHierarchy, 0));
};

function getFullData(compId) {
  return _.cloneDeep(_.get(this._model.components, [compId, FULL_DATA]));
}

function executeBehavior(behaviorType, behaviorName, params, compId, callback) {
  var behavior = {
    type: behaviorType,
    name: behaviorName,
    targetId: compId,
    requiresDom: { compId: compId },
    params: params
  };

  if (this._onUpdateCallback) {
    this._onUpdateCallback(compId, BEHAVIOR, behavior, callback);
  }
}

RemoteModelInterface.prototype.executeCompBehavior = function (compId, behaviorName, params, callback) {
  executeBehavior.call(this, 'comp', behaviorName, params, compId, callback);
};

RemoteModelInterface.prototype.executeAnimation = function (compId, animationName, params, callback) {
  executeBehavior.call(this, 'animation', animationName, params, compId, callback);
};

RemoteModelInterface.prototype.setUpdateCallback = function (onUpdateCallback) {
  this._onUpdateCallback = onUpdateCallback;
};

RemoteModelInterface.prototype.registerEvent = function (contextId, compId, eventType, controllerId, callback) {
  var callbackId = void 0;
  if (callback === undefined) {
    //TODO - backward compatibility - remove after SDK next release
    callback = controllerId;
    controllerId = undefined;
  }
  if (_.isFunction(callback)) {
    callbackId = guid();
    this._model.eventHandlers[callbackId] = { callback: callback, contextId: contextId, controllerId: controllerId };
  } else {
    callbackId = callback;
  }
  var eventDescriptor = {
    contextId: contextId,
    eventType: eventType,
    callbackId: callbackId
  };
  var component = _.get(this._model, ['components', compId]);
  if (component !== undefined) {
    this._hooksManager.executeHooksAndUpdateValue(this, 'registerEvent', component.type, compId, [contextId, eventType, controllerId, callback]);
    component.events.push({ eventType: eventType, callbackId: callbackId });
    if (this._transaction._onTransaction) {
      addItemToTransactionQueue.call(this, compId, 'registerEvent', eventDescriptor);
      return;
    }
    if (_.isFunction(this._onUpdateCallback)) {
      this._onUpdateCallback(compId, 'registerEvent', eventDescriptor);
    }
  }
};

RemoteModelInterface.prototype.toJson = function () {
  return this._model;
};

//General

RemoteModelInterface.prototype.getComponents = function () {
  var templateComponents = {};
  for (var compId in this._model.components) {
    //eslint-disable-line guard-for-in
    if (!modelUtils.isTemplateComp(this._model, compId)) {
      templateComponents[compId] = this.getComp(compId);
    }
  }

  return templateComponents;
};

RemoteModelInterface.prototype.getScopedRMI = function (controllerId) {
  var scopedRMI = new this.constructor(this._model, this._onUpdateCallback, { _hooksManager: this._hooksManager, _transaction: this._transaction });
  scopedRMI.getCompIdsFromRole = scopedRMI.getCompIdsFromRole.bind(scopedRMI, controllerId);
  scopedRMI.getCompIdsFromType = scopedRMI.getCompIdsFromType.bind(scopedRMI, controllerId);
  scopedRMI.getConfig = scopedRMI.getConfig.bind(scopedRMI, controllerId);

  return scopedRMI;
};

RemoteModelInterface.prototype.getNestedScopedRMI = function (model) {
  return new this.constructor(model || this._model, this._onUpdateCallback, { _hooksManager: this._hooksManager, _transaction: this._transaction });
};

RemoteModelInterface.prototype.getCompIdsFromType = function (controllerId, type, onlyNested) {
  var components = _.get(this._model.connections, controllerId);
  var compIds = _.flatMap(components, Object.keys);
  var comps = [];
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

  compIds.forEach(function (compId) {
    var compType = this.getType(compId);
    if (compType === type && acceptedScopes.includes(_.get(this._model.componentsScopes, compId))) {
      comps.push(compId);
    }
  }, this);
  return comps;
};

RemoteModelInterface.prototype.getCompIdsFromRole = function (controllerId, role, onlyNested) {
  var _this2 = this;

  var connectionConfigs = _.get(this._model.connections, [controllerId, role]);
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);
  var compIds = connectionConfigs ? Object.keys(connectionConfigs) : [];
  return compIds.filter(function (compId) {
    return acceptedScopes.includes(_.get(_this2._model.componentsScopes, compId));
  });
};

RemoteModelInterface.prototype.getConfig = function (controllerId, compId, role, onlyNested) {
  var connectionConfigs = _.get(this._model.connections, [controllerId, role]);
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

  return connectionConfigs && connectionConfigs.hasOwnProperty(compId) && acceptedScopes.includes(_.get(this._model.componentsScopes, compId)) ? connectionConfigs[compId] : {};
};

RemoteModelInterface.prototype.updateModel = function (modelUpdates) {
  for (var compId in modelUpdates) {
    //eslint-disable-line guard-for-in
    var defaultComp = generateDefaultCompStructure();
    var comp = _.get(this._model.components, compId);
    var compUpdates = modelUpdates[compId];
    if (!comp) {
      continue;
    }

    for (var keyToUpdate in compUpdates) {
      if (!_.has(comp, keyToUpdate)) {
        continue;
      }
      if (_.isObject(comp[keyToUpdate])) {
        if (compUpdates[keyToUpdate]) {
          _.assign(comp[keyToUpdate], compUpdates[keyToUpdate]);
        } else {
          // for modes change, when key should be initial to default value
          comp[keyToUpdate] = defaultComp[keyToUpdate];
        }
      } else {
        comp[keyToUpdate] = compUpdates[keyToUpdate];
      }
    }
  }
};

RemoteModelInterface.prototype.getScopedRMIByCompId = function (compId) {
  var itemContext = this.getRepeaterItemContext(compId);
  if (_.isEmpty(itemContext)) {
    return this;
  }

  var displayedRoot = itemContext.displayedRoot,
      itemId = itemContext.itemId;

  return this.getScopedRMIForRepeaterItem(displayedRoot, itemId);
};

RemoteModelInterface.prototype.getScopedRMIForRepeaterItem = function (repeaterId, itemId) {
  var model = _.clone(this._model);
  var templateCompIds = modelUtils.getAllCompsUnderRoot(model, repeaterId);
  var itemCompIds = templateCompIds.map(function (compId) {
    return repeaterUtils.structure.getUniqueDisplayedId(compId, itemId);
  });

  model.scopesHierarchy = _.clone(model.scopesHierarchy);
  model.scopesHierarchy.unshift({ type: COMPONENT_SCOPE, id: repeaterId, compId: repeaterId, additionalData: { itemId: itemId } });

  model.componentsScopes = _.clone(model.componentsScopes);
  templateCompIds.forEach(function (templateCompId) {
    return model.componentsScopes[templateCompId] = null;
  });
  itemCompIds.forEach(function (itemCompId) {
    return model.componentsScopes[itemCompId] = repeaterId;
  });

  return this.getNestedScopedRMI(model);
};

RemoteModelInterface.prototype.getRepeaterItemContext = function (compId) {
  var displayedRoot = _.get(this._model.components, [compId, DISPLAYED_ROOT]);

  if (!displayedRoot) {
    return {};
  }

  var itemId = repeaterUtils.structure.getItemId(compId);
  return { displayedRoot: displayedRoot, itemId: itemId };
};

RemoteModelInterface.prototype.startTransaction = function () {
  this._transaction._onTransaction = true;
};

RemoteModelInterface.prototype.endTransaction = function () {
  if (this._onUpdateCallback) {
    this._onUpdateCallback(null, 'executeBatch', this._transaction._transactionData);
  }
  this._transaction._onTransaction = false;
  this._transaction._transactionData = {};
};

RemoteModelInterface.prototype.setBatchData = function (newData) {
  _.forEach(newData, function (dataByProperty, compId) {
    _.forEach(dataByProperty, function (partialData, propertyType) {
      switch (propertyType) {
        case 'registerEvent':
          _.forEach(partialData, function (eventDescriptor) {
            this.registerEvent.call(this, eventDescriptor.contextId, compId, eventDescriptor.eventType, eventDescriptor.controllerId, eventDescriptor.callbackId);
          }.bind(this));
          break;
        default:
          var funcName = 'set' + _.startCase(propertyType);
          this[funcName].call(this, compId, partialData);
          break;
      }
    }.bind(this));
  }.bind(this));
};

RemoteModelInterface.prototype.registerHook = function (hookName, compType, callback) {
  this._hooksManager.registerHook(hookName, compType, callback);
};

RemoteModelInterface.prototype.getHooks = function () {
  return this._hooksManager.HOOKS;
};

//Utility

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function set(compId, property, partial, onUpdateCallback) {
  var comp = _.get(this._model, ['components', compId]);
  if (!comp) {
    return;
  }

  this._hooksManager.executeHooksAndUpdateValue(this, property, comp.type, compId, [partial, onUpdateCallback]);
  if (comp[IS_DISPLAYED]) {
    this._model.components[compId][property] = _.defaults({}, partial, comp[property]);
  }
  if (onUpdateCallback) {
    if (this._transaction._onTransaction) {
      addItemToTransactionQueue.call(this, compId, property, partial);
    } else {
      onUpdateCallback(compId, property, partial);
    }
  }
}

function addItemToTransactionQueue(compId, property, partial) {
  var transactionData = this._transaction._transactionData;
  if (!transactionData[compId]) {
    transactionData[compId] = {};
  }

  if (property === 'registerEvent') {
    if (!transactionData[compId][property]) {
      transactionData[compId][property] = [];
    }
    transactionData[compId][property].push(partial);
    return;
  }
  if (!transactionData[compId][property]) {
    transactionData[compId][property] = {};
  }
  _.assign(transactionData[compId][property], partial);
}

module.exports = RemoteModelInterface;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CHARS_TO_ADD = '...';
var NUM_OF_CHARS_TO_KEEP = 3;
var BG_VIDEO_DEFAULTS = {
  opacity: 1,
  autoplay: true,
  loop: true,
  preload: 'auto',
  mute: true
};
var MEDIA_PLAYER_DEFAULTS = {
  opacity: 1,
  autoplay: false,
  loop: false,
  preload: 'none',
  mute: false
};
var TITLE_LENGTH_LIMIT = 100;

function url2uri(url) {
  return url.replace(/^(.*[\/])/, '');
}

function getIdFromUrl(fileUrl) {
  var result = fileUrl.match(/(?:\/|^)([0-9a-fA-F_]+)(?:\/|$)/);
  return result.length > 1 ? result[1] : '';
}

function fixMediaTitleLength(value, lengthLimit) {
  if (value.length <= lengthLimit) {
    return value;
  }
  var arr = value.split('');
  var numOfCharsToRemove = value.length - lengthLimit + CHARS_TO_ADD.length;
  var isFileTypeSuffix = value.lastIndexOf('.') > value.length - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  var fileTypeSuffixIndex = isFileTypeSuffix ? value.lastIndexOf('.') : value.length - 1;
  var removeIndex = fileTypeSuffixIndex - numOfCharsToRemove - NUM_OF_CHARS_TO_KEEP;
  arr.splice(removeIndex, numOfCharsToRemove, CHARS_TO_ADD);
  return arr.join('');
}

/**
 * extracts the generated images from the video payload
 * @param fileInfo
 * @returns {[string]} images uri
 */
function parseVideoPosters(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  return _.map(fileOutput.image, function (image) {
    return url2uri(image.url);
  });
}

/**
 * extracts the video qualities from the video payload
 * @param fileInfo
 * @returns {[{width: number, height: number, quality: string, url: string} || {}]} qualities array
 */
function parseVideoQualities(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var mp4Videos = _.filter(fileOutput.video, { format: 'mp4' });
  var storyboard = _.head(_.get(fileOutput, 'storyboard'));
  var qualities = _.map(mp4Videos, function (quality) {
    return _.pick(quality, ['width', 'height', 'quality', 'url']);
  });

  if (storyboard) {
    qualities.push({
      quality: 'storyboard',
      width: storyboard.width,
      height: storyboard.height,
      url: storyboard.url
    });
  }

  return qualities;
}

/**
 * extracts the video adaptive formats and url from the video payload
 * @param fileInfo
 * @returns {[{format: string, url: string}] || []} qualities array
 */
function parseAdaptiveUrls(fileInfo) {
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var adaptiveVideo = fileOutput.adaptiveVideo || fileOutput.adaptive_video;
  return _.map(adaptiveVideo, function (item) {
    return {
      format: item.format,
      url: item.url
    };
  });
}

/**
 * parse media manager video file response into WixVideo object scheme
 * @param fileInfo - media manager, video file object response (https://docs.google.com/a/wix.com/document/d/1_fqnV0JcTfMHVpqKJIR9jFV-l6YGxv8_7cc3XQ7I2OY)
 * @param info - media manager, folder information
 * @returns {{type: string, title: *, videoId: string, duration: number, posterImageRef: *, generatedPosters: string[], qualities: ({width: number, height: number, quality: string, url: string}|{})[], artist: {name: (*|string), id: (*|string)}, hasAudio: boolean, fps: (string|*)}}
 * https://docs.google.com/a/wix.com/document/d/1BcbazImlny7Y5k4dE5B6n-FD4_NkXAeluefsl8324Js
 */
function parseVideoFileInfo(fileInfo, info) {
  var fileInput = fileInfo.fileInput || fileInfo.file_input;
  var fileOutput = fileInfo.fileOutput || fileInfo.file_output;
  var videoId = getIdFromUrl(fileInfo.fileUrl || fileInfo.file_name);
  var title = fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT);
  var qualities = parseVideoQualities(fileInfo);
  var adaptiveVideo = parseAdaptiveUrls(fileInfo);
  // parse poster - get the first item in data
  var imageData = _.head(fileOutput.image);
  var posterImageRef = {
    type: 'Image',
    width: imageData.width,
    height: imageData.height,
    uri: url2uri(imageData.url),
    description: info.path ? info.path : undefined
  };

  return {
    type: 'WixVideo',
    title: title,
    videoId: videoId,
    duration: +(fileInput.duration / 1000).toFixed(2),
    posterImageRef: posterImageRef,
    generatedPosters: parseVideoPosters(fileInfo),
    qualities: qualities,
    adaptiveVideo: adaptiveVideo,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' },
    hasAudio: _.head(fileOutput.video).audio_bitrate !== -1,
    fps: _.get(_.head(fileOutput.video), 'fps', '').toString()
  };
}

function getVideoBackgroundObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, BG_VIDEO_DEFAULTS);
}

function getMediaPlayerVideoObject(fileInfo, info) {
  var mediaObject = parseVideoFileInfo(fileInfo, info);
  return _.assign(mediaObject, MEDIA_PLAYER_DEFAULTS);
}

function getVideoPosterObject(videoId, uri, width, height) {
  return {
    type: 'WixVideo',
    videoId: videoId,
    posterImageRef: {
      type: 'Image',
      uri: uri,
      width: width,
      height: height
    }
  };
}

/**
 *
 * @param fileInfo
 * @param info - media manager, folder information
 * @returns {{uri: *, title: *, width: *, height: *}}
 */
function getImageBackgroundObject(fileInfo, info) {
  return {
    type: 'Image',
    uri: fileInfo.fileName,
    title: fixMediaTitleLength(fileInfo.title, TITLE_LENGTH_LIMIT),
    description: info.path,
    width: fileInfo.width,
    height: fileInfo.height,
    artist: { name: fileInfo.vendor || '', id: fileInfo.reference || '' }
  };
}

module.exports = {
  getVideoBackgroundObject: getVideoBackgroundObject,
  getVideoPosterObject: getVideoPosterObject,
  getMediaPlayerVideoObject: getMediaPlayerVideoObject,
  getImageBackgroundObject: getImageBackgroundObject,
  fixMediaTitleLength: fixMediaTitleLength
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _ = __webpack_require__(0);
var externalRegx = /^(http|https):\/\/(.*)/;
var mailtoRegx = /^mailto:([^\?]*)(?:\?subject=(.*)?)?/;
var pageRegx = /^\/([^ \?]*)[\?]?(.*)/;
var pageTopRegx = /^(\/?)([^ \?]*)#(top|SCROLL_TO_TOP)[\?]?(.*)/;
var pageBottomRegx = /^(\/?)([^ \?]*)#(bottom|SCROLL_TO_BOTTOM)[\?]?(.*)/;
var oldDocumentFormatRegx = /^document:\/\/(.*)/;
var newDocumentFormatRegx = /^wix:document:\/\/v1\/(.+)\/(.+)/;
var phoneRegx = /^tel:(.*)/;
var pageWithAnchor = /^\/([^ \?]*)#([^ \?]*)[\?]?(.*)/;
var samePageWithAnchor = /^#([^ \?]*)[\?]?(.*)/;
var ANCHOR_TYPE_TO_NAME = {
  SCROLL_TO_TOP: 'top',
  SCROLL_TO_BOTTOM: 'bottom'
};
var LinkType = {
  PAGE: 'PageLink',
  DYNAMIC_PAGE: 'DynamicPageLink',
  DYNAMIC_PAGE_WITH_QUERY_PARAMS: 'DynamicPageLinkWithQueryParams',
  EXTERNAL: 'ExternalLink',
  EMAIL: 'EmailLink',
  DOCUMENT: 'DocumentLink',
  PHONE: 'PhoneLink',
  PAGE_TOP: 'AnchorLink',
  PAGE_BOTTOM: 'AnchorLink',
  SAME_PAGE_ANCHOR_LINK: 'SamePageAnchorLink',
  ANCHOR: 'AnchorLink'
};

var SUPPORTED_TARGETS = ['_blank', '_self'];

var MASTER_PAGE_ID = 'masterPage';

var anchorLinkBaseTemplate = _.template('<%=linkObject.pageId%>#<%=linkObject.anchorDataId%>', { variable: 'linkObject' });
var pageLinkBaseTemplate = _.template('/<%=linkObject.pageId%>', { variable: 'linkObject' });

var UnsupportedLinkTypeError = function (_Error) {
  _inherits(UnsupportedLinkTypeError, _Error);

  function UnsupportedLinkTypeError() {
    _classCallCheck(this, UnsupportedLinkTypeError);

    var _this = _possibleConstructorReturn(this, (UnsupportedLinkTypeError.__proto__ || Object.getPrototypeOf(UnsupportedLinkTypeError)).call(this, 'Unsupported link type'));

    _this.name = 'UnsupportedLinkTypeError';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, UnsupportedLinkTypeError);
    }
    return _this;
  }

  return UnsupportedLinkTypeError;
}(Error);

var UnsupportedTargetValueError = function (_Error2) {
  _inherits(UnsupportedTargetValueError, _Error2);

  function UnsupportedTargetValueError() {
    _classCallCheck(this, UnsupportedTargetValueError);

    var _this2 = _possibleConstructorReturn(this, (UnsupportedTargetValueError.__proto__ || Object.getPrototypeOf(UnsupportedTargetValueError)).call(this, 'Unsupported target value'));

    _this2.name = 'UnsupportedTargetValueError';
    _this2.supportedTargets = SUPPORTED_TARGETS;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, UnsupportedTargetValueError);
    }
    return _this2;
  }

  return UnsupportedTargetValueError;
}(Error);

function getInnerRoute(parts, hasAnchor, hasQueryParams) {
  var partsWithoutQueryParams = parts;
  if (hasQueryParams) {
    partsWithoutQueryParams = _.dropRight(parts);
  }
  var partsWithoutPrefixAndSuffix = _.drop(hasAnchor ? _.dropRight(partsWithoutQueryParams) : partsWithoutQueryParams);
  return _.join(partsWithoutPrefixAndSuffix, '/');
}

var LINK_URL_TEMPLATES = {
  PageLink: {
    url: getPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes, siteStructurePages) {
      var pageLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], siteStructurePages)

      };
      if (parts.length === 3 && parts[2]) {
        _.assign(pageLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) || '' });
      }
      return pageLinkObj;
    },
    regex: [pageRegx]
  },
  DocumentLink: {
    url: _.template('wix:document://v1/<%=linkObject.docId%>/<%=linkObject.name%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        docId: parts[1],
        name: _.isUndefined(parts[2]) ? '' : parts[2]
      };
    },
    regex: [oldDocumentFormatRegx, newDocumentFormatRegx]
  },
  PhoneLink: {
    url: _.template('tel:<%=linkObject.phoneNumber%>', { variable: 'linkObject' }), link: function link(type, parts) {
      return {
        type: type,
        phoneNumber: parts[1]
      };
    },
    regex: [phoneRegx]
  },
  EmailLink: {
    url: getEmailLinkTemplate,
    link: function link(type, parts) {
      var data = {
        type: type,
        recipient: _.escape(parts[1])
      };
      if (parts[2]) {
        data.subject = _.escape(parts[2]);
      }
      return data;
    },

    regex: [mailtoRegx]
  },
  ExternalLink: {
    url: _.template('<%=linkObject.url%>', { variable: 'linkObject' }), link: function link(type, parts, siteStructurePrefixes, siteStructurePages, target) {
      if (target && !_.includes(SUPPORTED_TARGETS, target)) {
        throw new UnsupportedTargetValueError();
      }
      return {
        type: type,
        url: _.template('<%= partA %>://<%= partB%>')({ partA: parts[1], partB: parts[2] }),
        target: target || '_blank'
      };
    },
    regex: [externalRegx]
  },
  DynamicPageLink: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var hasAnchor = _.startsWith(_.last(parts), '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: type,
        innerRoute: getInnerRoute(parts, hasAnchor) || '/',
        routerId: routerData.id
      };
      if (hasAnchor) {
        var anchorName = _.last(parts).replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  DynamicPageLinkWithQueryParams: {
    url: getDynamicPageLinkTemplate, link: function link(type, parts, siteStructurePrefixes) {
      var queryParams = _.last(parts);
      var hasAnchor = _.startsWith(parts[parts.length - 2], '#');
      var routerData = _.find(siteStructurePrefixes, { name: parts[0] });
      var data = {
        type: LinkType.DYNAMIC_PAGE,
        innerRoute: getInnerRoute(parts, hasAnchor, true) || '/',
        routerId: routerData.id,
        queryParams: convertQueryParamsToObject(queryParams)

      };
      if (hasAnchor) {
        var anchorName = parts[parts.length - 2].replace('#', '');
        data.anchorDataId = _.get(_.invert(ANCHOR_TYPE_TO_NAME), anchorName, anchorName);
      }
      return data;
    },
    regex: [pageTopRegx, pageBottomRegx, pageWithAnchor, pageRegx]
  },
  AnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts, siteStructurePrefixes, pages) {
      var anchorDataId = parts[2];
      var anchorLinkObj = {
        type: type,
        pageId: '#' + translateUriSeoToPageId(parts[1], pages),
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId
      };
      if (parts.length === 4 && parts[3]) {
        _.assign(anchorLinkObj, { queryParams: convertQueryParamsToObject(parts[3]) });
      }
      return anchorLinkObj;
    },
    regex: [pageWithAnchor]
  },
  SamePageAnchorLink: {
    url: getAnchorLinkTemplate, link: function link(type, parts) {
      var anchorDataId = parts[1];
      var samePageAnchorLinkObj = {
        type: LinkType.ANCHOR,
        anchorDataId: _.invert(ANCHOR_TYPE_TO_NAME)[anchorDataId] || anchorDataId,
        pageId: '#' + MASTER_PAGE_ID
      };
      if (parts.length === 3 && parts[2]) {
        _.assign(samePageAnchorLinkObj, { queryParams: convertQueryParamsToObject(parts[2]) });
      }
      return samePageAnchorLinkObj;
    },
    regex: [samePageWithAnchor]
  }
};

function getUrlParts(regExpArr, value, type) {
  if (type === LinkType.DYNAMIC_PAGE || type === LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS) {
    return getDynamicPageParts(value);
  }
  var regexp = _.find(regExpArr, function (regExpItem) {
    return regExpItem.test(value);
  });
  var parts = value.match(regexp);
  parts = parts ? parts : [];
  return parts;
}

function getDynamicPageParts(str) {
  var pageRegRes = str.match(pageRegx);
  var parts = pageRegRes[1].replace('#', '/#').split(/[\/]+/);
  var hasQueryParam = _.includes(str, '?');
  if (hasQueryParam) {
    parts.push(_.last(pageRegRes));
  }
  return parts;
}

function getAnchorName(anchorDataId) {
  return ANCHOR_TYPE_TO_NAME[anchorDataId] || anchorDataId;
}

function getDynamicPagePrefix(siteStructurePrefixes, linkObject) {
  var routerConfig = _.find(siteStructurePrefixes, { id: linkObject.routerId });
  return routerConfig && routerConfig.prefix;
}

function getDynamicPageLinkTemplate(linkObject, siteStructurePrefixes) {
  var dynamicPageSuffix = !linkObject.innerRoute || linkObject.innerRoute === '/' ? '' : '/' + linkObject.innerRoute;
  var route = getDynamicPagePrefix(siteStructurePrefixes, linkObject) + dynamicPageSuffix;

  var anchorDataId = getAnchorName(linkObject.anchorDataId);
  var customLinkObject = {
    pageId: _.startsWith(route, '/') ? route : '/' + route,
    anchorDataId: anchorDataId
  };
  return customLinkObject.anchorDataId ? anchorLinkBaseTemplate(customLinkObject) : route;
}

function getPageLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? pageObj.url : pageLinkBaseTemplate({ pageId: pageId });
}

function getEmailLinkTemplate(linkObject) {
  var templateString = 'mailto:<%=linkObject.recipient%>';
  if (_.has(linkObject, 'subject')) {
    templateString += '?subject=<%=linkObject.subject%>';
  }

  return _.template(templateString, { variable: 'linkObject' })(linkObject);
}

function getAnchorLinkTemplate(linkObject, siteStructurePrefixes, siteStructurePages) {
  var anchorName = getAnchorName(linkObject.anchorDataId);
  if (isMasterPage(extractPageId(linkObject.pageId))) {
    return '#' + anchorName;
  }

  var pageId = getPageIdForURL(linkObject.pageId);
  var pageObj = _.find(siteStructurePages, { id: pageId });
  return pageObj ? anchorLinkBaseTemplate({
    pageId: pageObj.url,
    anchorDataId: anchorName
  }) : anchorLinkBaseTemplate({
    pageId: _.startsWith(pageId, '/') ? pageId : '/' + pageId,
    anchorDataId: anchorName
  });
}

function getPageIdForURL(pageId) {
  pageId = extractPageId(pageId);
  if (isMasterPage(pageId)) {
    return '';
  }

  return pageId.replace('#', '');
}

function extractPageId(pageId) {
  if (!pageId) {
    return pageId;
  }

  if (_.isPlainObject(pageId)) {
    if (pageId.pageUriSEO) {
      return pageId.pageUriSEO;
    } else if (isMasterPage(pageId.id)) {
      return MASTER_PAGE_ID;
    }

    throw new Error('pageId object should contain pageUriSEO');
  }

  return pageId;
}

function translateUriSeoToPageId(uriSeo, siteStructurePages) {
  var isHomePage = uriSeo === '';
  var pageData = isHomePage ? _.find(siteStructurePages, 'isMainPage') : _.find(siteStructurePages, { url: '/' + uriSeo });
  return _.get(pageData, 'id', uriSeo);
}

function isDynamicPage(urlParts, siteStructurePrefixes) {
  return _.find(siteStructurePrefixes, { name: urlParts[0] });
}

function getDynamicPageType(str) {
  return _.includes(str, '?') ? LinkType.DYNAMIC_PAGE_WITH_QUERY_PARAMS : LinkType.DYNAMIC_PAGE;
}

function isMasterPage(pageId) {
  return pageId.replace('#', '') === MASTER_PAGE_ID;
}

function getLinkType(str, siteStructurePrefixes) {
  switch (true) {
    case externalRegx.test(str):
      return LinkType.EXTERNAL;
    case mailtoRegx.test(str):
      return LinkType.EMAIL;
    case samePageWithAnchor.test(str):
      return LinkType.SAME_PAGE_ANCHOR_LINK;
    case pageTopRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_TOP;
    case pageBottomRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE_BOTTOM;
    case pageWithAnchor.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.ANCHOR;
    case pageRegx.test(str):
      return isDynamicPage(getDynamicPageParts(str), siteStructurePrefixes) ? getDynamicPageType(str) : LinkType.PAGE;
    case oldDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case newDocumentFormatRegx.test(str):
      return LinkType.DOCUMENT;
    case phoneRegx.test(str):
      return LinkType.PHONE;
    default:
      throw new UnsupportedLinkTypeError();
  }
}

function convertLinkObjectToUrl(siteStructurePrefixes, linkObject, siteStructurePages) {
  if (!linkObject || !_.get(LINK_URL_TEMPLATES, [linkObject.type, 'url'])) {
    throw new Error('Provided link type is not supported');
  }
  var urlTemplate = _.get(LINK_URL_TEMPLATES, [linkObject.type, 'url']);
  return urlTemplate(linkObject, siteStructurePrefixes, siteStructurePages);
}

function convertUrlToLinkObject(siteStructurePrefixes, url, target, siteStructurePages) {
  var type = getLinkType(url, siteStructurePrefixes);
  var urlParts = getUrlParts(LINK_URL_TEMPLATES[type].regex, url, type);
  var linkTemplate = _.get(LINK_URL_TEMPLATES, [type, 'link']);
  return linkTemplate(type, urlParts, siteStructurePrefixes, siteStructurePages, target);
}

function getAnchorDataId(linkItem) {
  return getAnchorName(linkItem.anchorDataId);
}

function getPageId(linkItem) {
  return extractPageId(linkItem.pageId);
}

function convertQueryParamsToObject(query) {
  if (!_.isString(query)) {
    return {};
  }
  var queryStringArray = query.split('&');
  return _.reduce(queryStringArray, function (res, queryParam) {
    var splitedQueryParam = queryParam.split("=");
    res[splitedQueryParam[0]] = splitedQueryParam[1] ? decodeURIComponent(splitedQueryParam[1]) : null;
    return res;
  }, {});
};

module.exports = {
  convertLinkObjectToUrl: convertLinkObjectToUrl,
  convertUrlToLinkObject: convertUrlToLinkObject,
  getAnchorDataId: getAnchorDataId,
  getPageId: getPageId,
  convertQueryParamsToObject: convertQueryParamsToObject
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var modelUtils = __webpack_require__(5);
var DELIMITER = '__';
var SPLITTED_DATA_TYPES = ['data', 'design'];

/* get Array[ids] or Array[{_id:id}] and returns array of id's*/
function getIdsFromItems(items) {
  return _.map(items, function (item) {
    return _.isString(item) ? item : item._id;
  });
}

/*get Array[ids] or Array[{_id:id}] and returns format of {item: itemData, index: index in array}*/
function reduceItems(data, ids) {
  var dataFormatted = _.map(data, function (v) {
    if (_.isString(v)) {
      return { _id: v };
    }
    return v;
  });
  return _.reduce(dataFormatted, function (result, item, index) {
    if (_.includes(ids, item._id)) {
      result.push({ item: item, index: index });
    }
    return result;
  }, []);
}

/*return added repeater items - check what newly ids were added
 * return {item: itemData, index: index in array} */
function getAddedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var newlyAddedItemsIds = _.difference(newItemsIds, currentDataIds);
  return reduceItems(newData, newlyAddedItemsIds);
}

/*return removed repeater items - check what ids were removed
 * return {item: itemData, index: index in array} */
function getRemovedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var removedIds = _.difference(currentDataIds, newItemsIds);
  return reduceItems(currentData, removedIds);
}

function getUniqueDisplayedId(originalId, itemId) {
  return originalId + DELIMITER + itemId;
}

function getOriginalId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[0];
}

function getItemId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[1];
}

function getTemplateCompIds(RMI, repeaterId, itemsData) {
  var templateCompIds = modelUtils.getAllCompsUnderRoot(_.get(RMI, '_model'), repeaterId);
  var itemsId = _.compact(_.map(itemsData, function (itemData) {
    return _.get(itemData, 'item._id');
  }));
  return _.reduce(itemsId, function (result, itemId) {
    return result.concat(_.map(templateCompIds, function (templateCompId) {
      return getUniqueDisplayedId(templateCompId, itemId);
    }));
  }, []);
}

module.exports = {
  getAddedItems: getAddedItems,
  getRemovedItems: getRemovedItems,
  getUniqueDisplayedId: getUniqueDisplayedId,
  getOriginalId: getOriginalId,
  getItemId: getItemId,
  getTemplateCompIds: getTemplateCompIds,
  SPLITTED_DATA_TYPES: SPLITTED_DATA_TYPES
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var styleMap = {
  p: 'font_8',
  h1: 'font_0',
  h2: 'font_2',
  h3: 'font_3',
  h4: 'font_4',
  h5: 'font_5',
  h6: 'font_6',
  ol: 'font_8',
  ul: 'font_8'
};

function applyTextStyles() {
  var htmlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!htmlString) {
    return htmlString;
  }
  var regexp = /<(ol|ul|h[1-6]|p)(.*?)>/g;
  var classRegexp = /class\s*?=\s*["'](.*?)['"]/;
  var g2ClassRegexp = /(class\s*?=\s*["'])(.*?)(['"])/;
  return htmlString.replace(regexp, function (match, g1, g2) {
    var matchedClassArray = g2.match(classRegexp);
    if (!matchedClassArray) {
      return '<' + g1 + g2 + ' class="' + styleMap[g1] + '">';
    }
    var matchedClass = matchedClassArray[1];
    if (/(^|\s)font_[0-9]($|\s)/.test(matchedClass)) {
      return match;
    } else if (g1 === 'p' && /\bp[13]\b/i.test(matchedClass)) {
      return match.replace(/(.*?\bclass\s*?=.*?)\bp([13])\b(.*)/, function (match, _g1, _g2, g3) {
        var _class = _g2 === '1' ? 'font_7' : 'font_9';
        return '' + _g1 + _class + g3;
      });
    }

    return '<' + g1 + g2.replace(g2ClassRegexp, function (_match, _g1, _g2, _g3) {
      return '' + _g1 + styleMap[g1] + ' ' + _g2 + _g3;
    }) + '>';
  });
}

function applyTransformationForSetHtml(value) {
  value = applyTextStyles(value);
  return value;
}

function applyTransformationForGetHtml() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var startBlockRegexp = /<(ol|ul|h[1-6]|p)(.*?)>/g;
  var p1p2regexp = /(class\s*=['"][^'"]*?)\bfont_([79])\b/;
  return data.replace(startBlockRegexp, function (match, tag) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var defaultClass = styleMap[tag];
    var defaultClassForTagRegexp = new RegExp('(class\\s*=[\'"].*?)' + defaultClass);
    if (defaultClassForTagRegexp.test(attributes)) {
      match = match.replace(defaultClassForTagRegexp, '$1');
    } else if (tag === 'p' && p1p2regexp.test(attributes)) {
      match = match.replace(p1p2regexp, function (match, prefix, p1p2) {
        return '' + prefix + (p1p2 === '7' ? 'p1' : 'p3');
      });
    }
    return match.replace(/class\s*=(['"])\s*\1/, '') //remove empty class attribute
    .replace(/class\s*=(['"])\s*(.*?)\s*\1/, function (_match, quote, classes) {
      return 'class=' + quote + classes + quote;
    }).replace(/(.+)\s{2,}/g, '$1 ') //remove pointless additional spaces e.g:class="a      b"
    .replace(/\s+>/, '>'); //remove pointless space from before closing tag
  });
}
module.exports = {
  applyTransformationForSetHtml: applyTransformationForSetHtml,
  applyTransformationForGetHtml: applyTransformationForGetHtml
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getSvgV1SkinName(url) {
  var split = url.replace('_', '.').replace('/', '.').split('.');
  return [split[2], split[3], 'svg_' + split[1], split[4]].join('.'); // eslint-disable-line
}

function getSvgV2SkinName(url) {
  //Example fileName: shapes/083ab0e246b24019a44c3d1e7096147f.svg
  //Example skinName: svgshape.v2.Svg_083ab0e246b24019a44c3d1e7096147f
  var regEx = /^shapes\/([a-z0-9]{32})\.svg$/i;
  var partsArr = regEx.exec(url);
  var md5Hash = partsArr[1];
  return 'svgshape.v2.Svg_' + md5Hash; // eslint-disable-line
}

module.exports = {
  parseSvgSkinFromUrl: function parseSvgSkinFromUrl(url) {
    return _.includes(url, '.v1.') ? getSvgV1SkinName(url) : getSvgV2SkinName(url);
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var sdkTypeByViewerType = {
  'wysiwyg.viewer.components.SiteButton': 'Button',
  'wysiwyg.viewer.components.PopupCloseTextButton': 'Button',
  'wysiwyg.viewer.components.PopupCloseIconButton': 'Button',
  'wysiwyg.common.components.imagebutton.viewer.ImageButton': 'Button',
  'wysiwyg.viewer.components.WPhoto': 'Image',
  'wysiwyg.viewer.components.FooterContainer': 'Footer',
  'wysiwyg.viewer.components.HeaderContainer': 'Header',
  'wysiwyg.viewer.components.WRichText': 'Text',
  'mobile.core.components.Page': 'Page',
  'wysiwyg.viewer.components.inputs.TextInput': 'TextInput',
  'wysiwyg.viewer.components.inputs.TextAreaInput': 'TextBox',
  'wysiwyg.viewer.components.inputs.DatePicker': 'DatePicker',
  'wysiwyg.viewer.components.BoxSlideShow': 'Slideshow',
  'wysiwyg.viewer.components.StripContainerSlideShow': 'Slideshow',
  'wysiwyg.viewer.components.SlideShowGallery': 'Gallery',
  'wysiwyg.viewer.components.SliderGallery': 'Gallery',
  'wysiwyg.viewer.components.MatrixGallery': 'Gallery',
  'wysiwyg.viewer.components.PaginatedGridGallery': 'Gallery',
  'mobile.core.components.Container': 'Box',
  'wysiwyg.viewer.components.Group': 'Box',
  'platform.components.AppController': 'AppController',
  'wysiwyg.viewer.components.svgshape.SvgShape': 'Shape',
  'wysiwyg.viewer.components.VectorImage': 'Shape',
  'wysiwyg.viewer.components.inputs.Checkbox': 'Checkbox',
  'wixui.ToggleSwitch': 'ToggleSwitch',
  'wysiwyg.viewer.components.inputs.RadioGroup': 'RadioButtonGroup',
  'wysiwyg.viewer.components.BoxSlideShowSlide': 'Slide',
  'wysiwyg.viewer.components.StripContainerSlideShowSlide': 'Slide',
  'wysiwyg.viewer.components.inputs.ComboBoxInput': 'Dropdown',
  'wysiwyg.viewer.components.Column': 'Column',
  'wysiwyg.viewer.components.StripColumnsContainer': 'ColumnStrip',
  'wysiwyg.viewer.components.Grid': 'Table',
  'wysiwyg.viewer.components.inputs.FileUploader': 'UploadButton',
  'wysiwyg.common.components.anchor.viewer.Anchor': 'Anchor',
  'wysiwyg.viewer.components.tpapps.TPASection': 'IFrame',
  'wysiwyg.viewer.components.tpapps.TPAMultiSection': 'IFrame',
  'wysiwyg.viewer.components.tpapps.TPAGluedWidget': 'IFrame',
  'wysiwyg.viewer.components.HtmlComponent': 'HtmlComponent',
  'wysiwyg.viewer.components.GoogleMap': 'GoogleMap',
  'wysiwyg.viewer.components.Video': 'Video',
  'wysiwyg.viewer.components.HoverBox': 'HoverBox',
  'tpa.viewer.components.Freestyle': 'Gallery',
  'tpa.viewer.components.Honeycomb': 'Gallery',
  'tpa.viewer.components.Accordion': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPA3DCarousel': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPA3DGallery': 'Gallery',
  'tpa.viewer.components.Impress': 'Gallery',
  'tpa.viewer.components.Masonry': 'Gallery',
  'tpa.viewer.components.Collage': 'Gallery',
  'tpa.viewer.components.StripSlideshow': 'Gallery',
  'tpa.viewer.components.StripShowcase': 'Gallery',
  'tpa.viewer.components.Thumbnails': 'Gallery',
  'wysiwyg.viewer.components.tpapps.TPAWidget': 'IFrame',
  'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu': 'VerticalMenu',
  'wysiwyg.viewer.components.LoginSocialBar': 'AccountNavBar',
  'wysiwyg.viewer.components.Repeater': 'Repeater',
  'wysiwyg.viewer.components.MediaContainer': 'Container',
  'wysiwyg.viewer.components.mobile.TinyMenu': 'MobileMenu'
};

var sdkTypeByWidgetId = {
  '142bb34d-3439-576a-7118-683e690a1e0d': 'Gallery'
};

var defaultSdkType = 'HiddenCollapsedElement';

module.exports = {
  sdkTypeByViewerType: sdkTypeByViewerType,
  sdkTypeByWidgetId: sdkTypeByWidgetId,
  defaultSdkType: defaultSdkType
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var _ = __webpack_require__(0);
var TPA_WIDGET_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidget';

var TypeUtils = function () {
  function TypeUtils(typesData) {
    _classCallCheck(this, TypeUtils);

    this._typesData = typesData;
  }

  _createClass(TypeUtils, [{
    key: 'getSdkType',
    value: function getSdkType(viewerType, tpaWidgetId) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;
      var defaultSdkType = typesData.defaultSdkType;
      return sdkTypeByWidgetId[tpaWidgetId] || sdkTypeByViewerType[viewerType] || defaultSdkType;
    }
  }, {
    key: 'getFullSdkType',
    value: function getFullSdkType(viewerType, tpaWidgetId) {
      return '$w.' + this.getSdkType(viewerType, tpaWidgetId);
    }
  }, {
    key: 'getPotentialViewerTypes',
    value: function getPotentialViewerTypes(sdkType) {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var types = _.keys(sdkTypeByViewerType);
      var resultViewerTypes = types.filter(function (viewerType) {
        return sdkTypeByViewerType[viewerType] === sdkType;
      });
      var isPotentiallyTPA = _.includes(_.values(sdkTypeByWidgetId), sdkType);
      if (isPotentiallyTPA) {
        resultViewerTypes.push('wysiwyg.viewer.components.tpapps.TPAWidget');
      }
      return resultViewerTypes;
    }
  }, {
    key: 'Types',
    get: function get() {
      var typesData = this._typesData;
      var sdkTypeByViewerType = typesData.sdkTypeByViewerType;
      var sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

      var allSdkTypes = _.uniq(_.values(sdkTypeByViewerType).concat(_.values(sdkTypeByWidgetId)));
      return _.zipObject(allSdkTypes, allSdkTypes);
    }
  }, {
    key: 'defaultSdkType',
    get: function get() {
      var typesData = this._typesData;
      return typesData.defaultSdkType;
    }
  }]);

  return TypeUtils;
}();

module.exports = TypeUtils;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _ = __webpack_require__(0);
var IMAGE_URI = 'image://';
var DOC_URI = 'wix:document://';
var VERSION = 'v1';
var wixCodeImgUriTemplate = _.template(IMAGE_URI + VERSION + '/${uri}/${width}_${height}/${title}');
var wixCodeDocUriTemplate = _.template(DOC_URI + VERSION + '/${uri}/${filename}');
var MEDIA_SRC_REGEX = /^image:\/\/(.*)\/(.*)\/(.*)_(.*)\/(.*)/;

function generateWixCodeImageUri(imageData) {
  return wixCodeImgUriTemplate(imageData);
}

function generateWixCodeDocumentUri(documentData) {
  return wixCodeDocUriTemplate(documentData);
}

function removeEmptyValues(res, v, k) {
  if (v) {
    res[k] = v;
  }
  return res;
}

function extractImageRelativeUriFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        _ref2 = _slicedToArray(_ref, 3),
        baseSrc = _ref2[2];

    return baseSrc;
  }

  return wixCodeImageUri;
}

function extractImageDataFromWixUri(wixCodeImageUri) {
  if (MEDIA_SRC_REGEX.test(wixCodeImageUri)) {
    var _ref3 = wixCodeImageUri.match(MEDIA_SRC_REGEX) || [0, 0, wixCodeImageUri],
        _ref4 = _slicedToArray(_ref3, 6),
        uri = _ref4[2],
        width = _ref4[3],
        height = _ref4[4],
        title = _ref4[5];

    return _.reduce({ uri: uri, width: width, height: height, title: title }, removeEmptyValues, {});
  }

  return { uri: wixCodeImageUri };
}

module.exports = {
  generateWixCodeImageUri: generateWixCodeImageUri,
  generateWixCodeDocumentUri: generateWixCodeDocumentUri,
  extractImageRelativeUriFromWixUri: extractImageRelativeUriFromWixUri,
  extractImageDataFromWixUri: extractImageDataFromWixUri
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrl = 'https://dailymotion.com/video/';
  return baseUrl + videoId;
}

function getVideoIdFromUrl(url) {

  var urlRegex = /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.facebook.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  var urlRegex = /facebook\.com\/(.+\/videos\/[A-Za-z0-9._%-]*)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var youtubeVideoUtils = __webpack_require__(37);
var vimeoVideoUtils = __webpack_require__(36);
var dailymotionVideoUtils = __webpack_require__(33);
var facebookVideoUtils = __webpack_require__(34);
var _ = __webpack_require__(0);

// TODO: unite with santa viewer

var VIDEO_UTILS_PROVIDERS = {
  YOUTUBE: youtubeVideoUtils,
  VIMEO: vimeoVideoUtils,
  DAILYMOTION: dailymotionVideoUtils,
  FACEBOOK: facebookVideoUtils
};

function getMethodForType(videoType, methodName) {
  return VIDEO_UTILS_PROVIDERS[videoType.toUpperCase()] && VIDEO_UTILS_PROVIDERS[videoType][methodName];
}

/**
 * @param {{videoType: string, videoId: string}} videoData
 * @returns {string}
 */
function getVideoUrl(videoData) {
  if (videoData && videoData.videoType && videoData.videoId) {
    var videoUrlGetter = getMethodForType(videoData.videoType, 'getVideoUrl');
    return videoUrlGetter && videoUrlGetter(videoData.videoId) || '';
  }

  return '';
}

/**
 * @param {string} videoUrl
 * @returns {videoData}
 */
function getVideoDataFromUrl(videoUrl) {
  var videoData = void 0;
  _.forEach(VIDEO_UTILS_PROVIDERS, function (methods, videoType) {
    var videoIdGetter = getMethodForType(videoType, 'getVideoIdFromUrl');
    var videoId = videoIdGetter && videoIdGetter(videoUrl);
    if (!_.isEmpty(videoId)) {
      videoData = {
        videoType: videoType,
        videoId: videoId
      };
      return false; // break forEach
    }
  });
  return videoData;
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoDataFromUrl: getVideoDataFromUrl,
  videoTypes: {
    YOUTUBE: 'YOUTUBE',
    VIMEO: 'VIMEO',
    DAILYMOTION: 'DAILYMOTION',
    FACEBOOK: 'FACEBOOK'
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://vimeo.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional vimeo url formats
  var vimeoUrlRegex = /vimeo\.com\/(\d+)$/gi;
  var match = vimeoUrlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.youtube.com/watch?v=';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional youtube url formats
  // Test for long youtube url: http://youtube.com/watch?[...&]v=[VIDEO_ID]
  var YTLongUrl = /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/g;
  // Test for short youtube url: http://youtu.be/[VIDEO_ID]
  var YTShortUrl = /(?:youtu\.be\/)([\w-]+)/g;

  var match = YTLongUrl.exec(url) || YTShortUrl.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var DEFAULT_STYLE_PARAMS = {
  backgroundColor: 'bg',
  borderColor: 'brd',
  borderWidth: 'brw',
  borderRadius: 'rd',
  color: 'txt'
};

var STYLE_PARAMS_OVERRIDES = {
  'wysiwyg.viewer.components.inputs.FileUploader': {
    backgroundColor: 'btn_bg',
    borderColor: 'btn_brd',
    borderWidth: 'btn_brw',
    borderRadius: 'btn_rd',
    color: 'btn_txt'
  }
};

function convertStyleParamForViewerType(viewerType, styleParam) {
  var overrides = _.get(STYLE_PARAMS_OVERRIDES, viewerType);
  var styleParamMap = overrides ? overrides : DEFAULT_STYLE_PARAMS;
  return _.get(styleParamMap, styleParam);
}

module.exports = {
  convertStyleParamForViewerType: convertStyleParamForViewerType
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var msgIntent = 'WIX_CODE_SITE_API';
var REPORT_BI_MESSAGE_TYPE = 'reportBI';

function report(sendMsgFunc, reportDef, params) {
  var definition = _.defaults({ endpoint: 'platform-viewer' }, reportDef);
  sendMsgFunc({
    intent: msgIntent,
    type: REPORT_BI_MESSAGE_TYPE,
    reportDef: definition,
    params: params
  });
}

module.exports = {
  report: report
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function createBiSession(metaSiteId, viewerSessionId, ownerId) {
  return {
    get metaSiteId() {
      return metaSiteId;
    },
    get viewerSessionId() {
      return viewerSessionId;
    },
    get ownerId() {
      return ownerId;
    }
  };
}

module.exports = {
  createBiSession: createBiSession
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var platformUtils = __webpack_require__(10);

module.exports = {
  getApi: function getApi(routersMap, appStorage) {
    return {
      links: {
        toUrl: platformUtils.linkUtils.convertLinkObjectToUrl.bind(platformUtils.linkUtils, routersMap)
      },
      storage: appStorage
    };
  }
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function assign(to) {
  Array.prototype.forEach.call(arguments, function (from) {
    if (_.isNil(from) || from === to) {
      return;
    }
    from = Object(from);

    Object.keys(from).forEach(function (key) {
      var desc = Object.getOwnPropertyDescriptor(from, key);
      if (desc !== undefined && desc.enumerable) {
        to[key] = from[key];
      }
    });
  });
  return to;
}

module.exports = {
  assign: assign
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  INFO: 'INFO',
  WARN: 'WARNING',
  ERROR: 'ERROR',
  LOG: 'LOG'
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function runScript(devConsole, appId, script, moduleFunc, storage, routerData) {
  if (devConsole.info) {
    devConsole.info('Loading the code for the ' + script.displayName + '. To debug this code, open ' + script.scriptName + ' in Developer Tools.');
  }

  self.$w = self.wix.getSelector(script.id, script.displayName);
  self.routerReturnedData = routerData;
  self['wix-storage'] = self.wix.getStorage(appId, storage);

  var module;
  try {
    module = moduleFunc();
  } catch (e) {
    devConsole.error('There was an error in your script');
    devConsole.error(e);
  }

  delete self.$w;
  delete self.routerReturnedData;
  delete self['wix-storage'];

  return module;
}

module.exports = {
  runScript: runScript
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,r){ true?module.exports=r():"function"==typeof define&&define.amd?define("pmrpc",[],r):"object"==typeof exports?exports.pmrpc=r():t.pmrpc=r()}(this,function(){return function(t){function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}var e={};return r.m=t,r.c=e,r.i=function(t){return t},r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,r){return Object.prototype.hasOwnProperty.call(t,r)},r.p="",r(r.s=150)}([function(t,r){var e=Array.isArray;t.exports=e},function(t,r,e){var n=e(40),o="object"==typeof self&&self&&self.Object===Object&&self,i=n||o||Function("return this")();t.exports=i},function(t,r,e){function n(t){return null==t?void 0===t?a:c:s&&s in Object(t)?i(t):u(t)}var o=e(9),i=e(99),u=e(125),c="[object Null]",a="[object Undefined]",s=o?o.toStringTag:void 0;t.exports=n},function(t,r,e){function n(t,r){var e=i(t,r);return o(e)?e:void 0}var o=e(35),i=e(101);t.exports=n},function(t,r){function e(t){return null!=t&&"object"==typeof t}t.exports=e},function(t,r,e){function n(t){if(!i(t))return!1;var r=o(t);return r==c||r==a||r==u||r==s}var o=e(2),i=e(6),u="[object AsyncFunction]",c="[object Function]",a="[object GeneratorFunction]",s="[object Proxy]";t.exports=n},function(t,r){function e(t){var r=typeof t;return null!=t&&("object"==r||"function"==r)}t.exports=e},function(t,r,e){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default={INVOKE:"invoke",RPC_RESOLVE:"rpc-resolve",RPC_REJECT:"rpc-reject",API_DESCRIPTION:"api-desc",INVOKE_FUNCTION:"invoke-func",RESOLVE:"resolve",REJECT:"reject",REQUEST_API:"request-api"}},function(t,r,e){function n(t){var r=-1,e=null==t?0:t.length;for(this.clear();++r<e;){var n=t[r];this.set(n[0],n[1])}}var o=e(111),i=e(112),u=e(113),c=e(114),a=e(115);n.prototype.clear=o,n.prototype.delete=i,n.prototype.get=u,n.prototype.has=c,n.prototype.set=a,t.exports=n},function(t,r,e){var n=e(1),o=n.Symbol;t.exports=o},function(t,r,e){function n(t,r){for(var e=t.length;e--;)if(o(t[e][0],r))return e;return-1}var o=e(49);t.exports=n},function(t,r,e){function n(t,r){var e=t.__data__;return o(r)?e["string"==typeof r?"string":"hash"]:e.map}var o=e(108);t.exports=n},function(t,r,e){var n=e(3),o=n(Object,"create");t.exports=o},function(t,r,e){function n(t){if("string"==typeof t||o(t))return t;var r=t+"";return"0"==r&&1/t==-i?"-0":r}var o=e(27),i=1/0;t.exports=n},function(t,r,e){function n(t,r,e){var n=null==t?void 0:o(t,r);return void 0===n?e:n}var o=e(33);t.exports=n},function(t,r,e){function n(t){return null!=t&&i(t.length)&&!o(t)}var o=e(5),i=e(26);t.exports=n},function(t,r,e){(function(t){var n=e(1),o=e(50),i="object"==typeof r&&r&&!r.nodeType&&r,u=i&&"object"==typeof t&&t&&!t.nodeType&&t,c=u&&u.exports===i,a=c?n.Buffer:void 0,s=a?a.isBuffer:void 0,f=s||o;t.exports=f}).call(r,e(52)(t))},function(t,r,e){var n=e(82),o=e(90),i=e(124),u=i&&i.isTypedArray,c=u?o(u):n;t.exports=c},function(t,r,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(r,"__esModule",{value:!0}),r.deserialize=r.serialize=void 0;var o=e(14),i=n(o),u=e(138),c=n(u),a=e(139),s=n(a),f=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.type;return"Error"===r||(0,c.default)((0,i.default)(self,[r,"prototype"]))},l=function(t){var r=t.type,e=t.stack,n=t.message,o=new self[r](n);return o.stack=e,o},p=function(t){var r=t.constructor.name,e=t.message,n=t.stack;return{type:(0,s.default)(self[r])?r:"Error",message:e,stack:n}};r.serialize=function(t){return Promise.reject((0,c.default)(t)?p(t):t)},r.deserialize=function(t){return f(t)?l(t):t}},function(t,r,e){"use strict";function n(t){if(Array.isArray(t)){for(var r=0,e=Array(t.length);r<t.length;r++)e[r]=t[r];return e}return Array.from(t)}Object.defineProperty(r,"__esModule",{value:!0}),r.sendResponse=r.send=void 0;var o=e(30);r.send=function(t,r){var e=r.target,i=r.targetOrigin,u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return new Promise(function(r){var c=new MessageChannel,a=c.port1,s=c.port2;t.__port=s,(0,o.isWorker)()||e instanceof Worker||e instanceof MessagePort?e.postMessage(t,[s].concat(n(u))):e.postMessage(t,i,[s].concat(n(u))),a.onmessage=function(t){var e=t.data;return r(e)}})},r.sendResponse=function(t,r){return function(e){return t.postMessage({intent:r,result:e})}}},function(t,r,e){var n=e(3),o=e(1),i=n(o,"Map");t.exports=i},function(t,r,e){function n(t){var r=-1,e=null==t?0:t.length;for(this.clear();++r<e;){var n=t[r];this.set(n[0],n[1])}}var o=e(116),i=e(117),u=e(118),c=e(119),a=e(120);n.prototype.clear=o,n.prototype.delete=i,n.prototype.get=u,n.prototype.has=c,n.prototype.set=a,t.exports=n},function(t,r,e){function n(t,r){return t&&o(t,r,i)}var o=e(76),i=e(28);t.exports=n},function(t,r,e){function n(t){return"function"==typeof t?t:null==t?u:"object"==typeof t?c(t)?i(t[0],t[1]):o(t):a(t)}var o=e(84),i=e(85),u=e(136),c=e(0),a=e(144);t.exports=n},function(t,r,e){function n(t,r){if(o(t))return!1;var e=typeof t;return!("number"!=e&&"symbol"!=e&&"boolean"!=e&&null!=t&&!i(t))||(c.test(t)||!u.test(t)||null!=r&&t in Object(r))}var o=e(0),i=e(27),u=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,c=/^\w*$/;t.exports=n},function(t,r,e){var n=e(79),o=e(4),i=Object.prototype,u=i.hasOwnProperty,c=i.propertyIsEnumerable,a=n(function(){return arguments}())?n:function(t){return o(t)&&u.call(t,"callee")&&!c.call(t,"callee")};t.exports=a},function(t,r){function e(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=n}var n=9007199254740991;t.exports=e},function(t,r,e){function n(t){return"symbol"==typeof t||i(t)&&o(t)==u}var o=e(2),i=e(4),u="[object Symbol]";t.exports=n},function(t,r,e){function n(t){return u(t)?o(t):i(t)}var o=e(70),i=e(36),u=e(15);t.exports=n},function(t,r,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(r,"__esModule",{value:!0});var o=e(7),i=n(o),u=e(18);r.default=function(t){var r=t.intent,e=t.result;switch(r){case i.default.RESOLVE:return e;case i.default.REJECT:return Promise.reject((0,u.deserialize)(e))}}},function(t,r,e){"use strict";Object.defineProperty(r,"__esModule",{value:!0});var n=function(){return"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope},o=function(t){return document.getElementById(t)};r.isWorker=n,r.getChildFrameById=o},function(t,r,e){function n(t){var r=this.__data__=new o(t);this.size=r.size}var o=e(8),i=e(129),u=e(130),c=e(131),a=e(132),s=e(133);n.prototype.clear=i,n.prototype.delete=u,n.prototype.get=c,n.prototype.has=a,n.prototype.set=s,t.exports=n},function(t,r){function e(t,r){for(var e=-1,n=null==t?0:t.length,o=Array(n);++e<n;)o[e]=r(t[e],e,t);return o}t.exports=e},function(t,r,e){function n(t,r){r=o(r,t);for(var e=0,n=r.length;null!=t&&e<n;)t=t[i(r[e++])];return e&&e==n?t:void 0}var o=e(37),i=e(13);t.exports=n},function(t,r,e){function n(t,r,e,u,c){return t===r||(null==t||null==r||!i(t)&&!i(r)?t!==t&&r!==r:o(t,r,e,u,n,c))}var o=e(80),i=e(4);t.exports=n},function(t,r,e){function n(t){return!(!u(t)||i(t))&&(o(t)?h:s).test(c(t))}var o=e(5),i=e(110),u=e(6),c=e(48),a=/[\\^$.*+?()[\]{}|]/g,s=/^\[object .+?Constructor\]$/,f=Function.prototype,l=Object.prototype,p=f.toString,v=l.hasOwnProperty,h=RegExp("^"+p.call(v).replace(a,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=n},function(t,r,e){function n(t){if(!o(t))return i(t);var r=[];for(var e in Object(t))c.call(t,e)&&"constructor"!=e&&r.push(e);return r}var o=e(44),i=e(123),u=Object.prototype,c=u.hasOwnProperty;t.exports=n},function(t,r,e){function n(t,r){return o(t)?t:i(t,r)?[t]:u(c(t))}var o=e(0),i=e(24),u=e(134),c=e(146);t.exports=n},function(t,r,e){var n=e(1),o=n["__core-js_shared__"];t.exports=o},function(t,r,e){function n(t,r,e,n,s,f){var l=e&c,p=t.length,v=r.length;if(p!=v&&!(l&&v>p))return!1;var h=f.get(t);if(h&&f.get(r))return h==r;var d=-1,y=!0,_=e&a?new o:void 0;for(f.set(t,r),f.set(r,t);++d<p;){var b=t[d],g=r[d];if(n)var x=l?n(g,b,d,r,t,f):n(b,g,d,t,r,f);if(void 0!==x){if(x)continue;y=!1;break}if(_){if(!i(r,function(t,r){if(!u(_,r)&&(b===t||s(b,t,e,n,f)))return _.push(r)})){y=!1;break}}else if(b!==g&&!s(b,g,e,n,f)){y=!1;break}}return f.delete(t),f.delete(r),y}var o=e(65),i=e(72),u=e(91),c=1,a=2;t.exports=n},function(t,r,e){(function(r){var e="object"==typeof r&&r&&r.Object===Object&&r;t.exports=e}).call(r,e(51))},function(t,r,e){var n=e(47),o=n(Object.getPrototypeOf,Object);t.exports=o},function(t,r,e){var n=e(61),o=e(20),i=e(63),u=e(64),c=e(67),a=e(2),s=e(48),f="[object Map]",l="[object Promise]",p="[object Set]",v="[object WeakMap]",h="[object DataView]",d=s(n),y=s(o),_=s(i),b=s(u),g=s(c),x=a;(n&&x(new n(new ArrayBuffer(1)))!=h||o&&x(new o)!=f||i&&x(i.resolve())!=l||u&&x(new u)!=p||c&&x(new c)!=v)&&(x=function(t){var r=a(t),e="[object Object]"==r?t.constructor:void 0,n=e?s(e):"";if(n)switch(n){case d:return h;case y:return f;case _:return l;case b:return p;case g:return v}return r}),t.exports=x},function(t,r){function e(t,r){return!!(r=null==r?n:r)&&("number"==typeof t||o.test(t))&&t>-1&&t%1==0&&t<r}var n=9007199254740991,o=/^(?:0|[1-9]\d*)$/;t.exports=e},function(t,r){function e(t){var r=t&&t.constructor;return t===("function"==typeof r&&r.prototype||n)}var n=Object.prototype;t.exports=e},function(t,r,e){function n(t){return t===t&&!o(t)}var o=e(6);t.exports=n},function(t,r){function e(t,r){return function(e){return null!=e&&(e[t]===r&&(void 0!==r||t in Object(e)))}}t.exports=e},function(t,r){function e(t,r){return function(e){return t(r(e))}}t.exports=e},function(t,r){function e(t){if(null!=t){try{return o.call(t)}catch(t){}try{return t+""}catch(t){}}return""}var n=Function.prototype,o=n.toString;t.exports=e},function(t,r){function e(t,r){return t===r||t!==t&&r!==r}t.exports=e},function(t,r){function e(){return!1}t.exports=e},function(t,r){var e;e=function(){return this}();try{e=e||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,r){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,r,e){t.exports="function"==typeof Array.from?Array.from:e(56)},function(t,r,e){"use strict";function n(t){if(t&&t.__esModule)return t;var r={};if(null!=t)for(var e in t)Object.prototype.hasOwnProperty.call(t,e)&&(r[e]=t[e]);return r.default=t,r}function o(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(r,"__esModule",{value:!0}),r.unset=r.request=r.set=void 0;var i=e(14),u=o(i),c=e(58),a=n(c),s=e(30),f=e(7),l=o(f),p=e(57),v=e(19),h=e(60),d=n(h),y=e(18),_=function(t){var r=t.target,e=t.initiator;switch(!0){case(0,s.isWorker)():return{target:self,targetOrigin:"*"};case r===parent:return{target:parent,targetOrigin:"*"};case r instanceof Worker:return{target:r};case Boolean(r):return r.contentWindow?{target:r.contentWindow,targetOrigin:r.src}:{target:r,targetOrigin:"*"};case Boolean(e):var n=(0,s.getChildFrameById)(e);return{target:n.contentWindow,targetOrigin:n.src};default:throw new Error("Invalid target")}},b=function(t){var r=t.data,e=r.appId,n=r.intent,o=r.call,i=r.args,c=r.__port,s=t.ports;s=s||[];var f=c||s[0];switch(n){case l.default.REQUEST_API:var h=a.getAppById(e),d=h?(0,p.getDescription)(h):null;return void f.postMessage(d);case l.default.INVOKE_FUNCTION:var _=a.getAppData(e);if(!_){var b=new Error("The API for "+e+" has been removed");return(0,v.sendResponse)(f,l.default.REJECT)((0,y.serialize)(b))}_.onApiCall&&_.onApiCall({appId:e,call:o,args:i});var g=(0,u.default)(_.app,o);return(0,p.invokeApiFunction)(g,i,s.slice(1)).then((0,v.sendResponse)(f,l.default.RESOLVE),(0,v.sendResponse)(f,l.default.REJECT))}};r.set=function(t,r){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=e.onApiCall;a.hasApp(t)&&a.unregisterApp(t),a.registerApp(t,r,n),d.addSingleHandler(b)},r.request=function(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},e=_(r);return(0,v.send)({intent:l.default.REQUEST_API,appId:t},e).then(function(r){return r?(0,p.buildApiFromDescription)(t,r,e):Promise.reject(new Error("App with ID "+t+" not found"))})},r.unset=function(t){a.unregisterApp(t),a.isEmpty()&&d.removeSingleHandler(b)}},function(t,r,e){(function(r,n){!function(r,e){t.exports=e()}(0,function(){"use strict";function t(t){return"function"==typeof t||"object"==typeof t&&null!==t}function o(t){return"function"==typeof t}function i(t){G=t}function u(t){Q=t}function c(){return function(){return r.nextTick(p)}}function a(){return void 0!==H?function(){H(p)}:l()}function s(){var t=0,r=new Z(p),e=document.createTextNode("");return r.observe(e,{characterData:!0}),function(){e.data=t=++t%2}}function f(){var t=new MessageChannel;return t.port1.onmessage=p,function(){return t.port2.postMessage(0)}}function l(){var t=setTimeout;return function(){return t(p,1)}}function p(){for(var t=0;t<K;t+=2){(0,et[t])(et[t+1]),et[t]=void 0,et[t+1]=void 0}K=0}function v(){try{var t=e(149);return H=t.runOnLoop||t.runOnContext,a()}catch(t){return l()}}function h(t,r){var e=arguments,n=this,o=new this.constructor(y);void 0===o[ot]&&R(o);var i=n._state;return i?function(){var t=e[i-1];Q(function(){return k(i,o,t,n._result)})}():S(n,o,t,r),o}function d(t){var r=this;if(t&&"object"==typeof t&&t.constructor===r)return t;var e=new r(y);return O(e,t),e}function y(){}function _(){return new TypeError("You cannot resolve a promise with itself")}function b(){return new TypeError("A promises callback cannot return that same promise.")}function g(t){try{return t.then}catch(t){return at.error=t,at}}function x(t,r,e,n){try{t.call(r,e,n)}catch(t){return t}}function j(t,r,e){Q(function(t){var n=!1,o=x(e,r,function(e){n||(n=!0,r!==e?O(t,e):E(t,e))},function(r){n||(n=!0,P(t,r))},"Settle: "+(t._label||" unknown promise"));!n&&o&&(n=!0,P(t,o))},t)}function m(t,r){r._state===ut?E(t,r._result):r._state===ct?P(t,r._result):S(r,void 0,function(r){return O(t,r)},function(r){return P(t,r)})}function w(t,r,e){r.constructor===t.constructor&&e===h&&r.constructor.resolve===d?m(t,r):e===at?(P(t,at.error),at.error=null):void 0===e?E(t,r):o(e)?j(t,r,e):E(t,r)}function O(r,e){r===e?P(r,_()):t(e)?w(r,e,g(e)):E(r,e)}function A(t){t._onerror&&t._onerror(t._result),T(t)}function E(t,r){t._state===it&&(t._result=r,t._state=ut,0!==t._subscribers.length&&Q(T,t))}function P(t,r){t._state===it&&(t._state=ct,t._result=r,Q(A,t))}function S(t,r,e,n){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=r,o[i+ut]=e,o[i+ct]=n,0===i&&t._state&&Q(T,t)}function T(t){var r=t._subscribers,e=t._state;if(0!==r.length){for(var n=void 0,o=void 0,i=t._result,u=0;u<r.length;u+=3)n=r[u],o=r[u+e],n?k(e,n,o,i):o(i);t._subscribers.length=0}}function M(){this.error=null}function z(t,r){try{return t(r)}catch(t){return st.error=t,st}}function k(t,r,e,n){var i=o(e),u=void 0,c=void 0,a=void 0,s=void 0;if(i){if(u=z(e,n),u===st?(s=!0,c=u.error,u.error=null):a=!0,r===u)return void P(r,b())}else u=n,a=!0;r._state!==it||(i&&a?O(r,u):s?P(r,c):t===ut?E(r,u):t===ct&&P(r,u))}function I(t,r){try{r(function(r){O(t,r)},function(r){P(t,r)})}catch(r){P(t,r)}}function C(){return ft++}function R(t){t[ot]=ft++,t._state=void 0,t._result=void 0,t._subscribers=[]}function F(t,r){this._instanceConstructor=t,this.promise=new t(y),this.promise[ot]||R(this.promise),J(r)?(this._input=r,this.length=r.length,this._remaining=r.length,this._result=new Array(this.length),0===this.length?E(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&E(this.promise,this._result))):P(this.promise,D())}function D(){return new Error("Array Methods must be provided an Array")}function L(t){return new F(this,t).promise}function N(t){var r=this;return new r(J(t)?function(e,n){for(var o=t.length,i=0;i<o;i++)r.resolve(t[i]).then(e,n)}:function(t,r){return r(new TypeError("You must pass an array to race."))})}function B(t){var r=this,e=new r(y);return P(e,t),e}function U(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function W(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function V(t){this[ot]=C(),this._result=this._state=void 0,this._subscribers=[],y!==t&&("function"!=typeof t&&U(),this instanceof V?I(this,t):W())}function $(){var t=void 0;if(void 0!==n)t=n;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var r=t.Promise;if(r){var e=null;try{e=Object.prototype.toString.call(r.resolve())}catch(t){}if("[object Promise]"===e&&!r.cast)return}t.Promise=V}var q=void 0;q=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var J=q,K=0,H=void 0,G=void 0,Q=function(t,r){et[K]=t,et[K+1]=r,2===(K+=2)&&(G?G(p):nt())},Y="undefined"!=typeof window?window:void 0,X=Y||{},Z=X.MutationObserver||X.WebKitMutationObserver,tt="undefined"==typeof self&&void 0!==r&&"[object process]"==={}.toString.call(r),rt="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,et=new Array(1e3),nt=void 0;nt=tt?c():Z?s():rt?f():void 0===Y?v():l();var ot=Math.random().toString(36).substring(16),it=void 0,ut=1,ct=2,at=new M,st=new M,ft=0;return F.prototype._enumerate=function(){for(var t=this.length,r=this._input,e=0;this._state===it&&e<t;e++)this._eachEntry(r[e],e)},F.prototype._eachEntry=function(t,r){var e=this._instanceConstructor,n=e.resolve;if(n===d){var o=g(t);if(o===h&&t._state!==it)this._settledAt(t._state,r,t._result);else if("function"!=typeof o)this._remaining--,this._result[r]=t;else if(e===V){var i=new e(y);w(i,t,o),this._willSettleAt(i,r)}else this._willSettleAt(new e(function(r){return r(t)}),r)}else this._willSettleAt(n(t),r)},F.prototype._settledAt=function(t,r,e){var n=this.promise;n._state===it&&(this._remaining--,t===ct?P(n,e):this._result[r]=e),0===this._remaining&&E(n,this._result)},F.prototype._willSettleAt=function(t,r){var e=this;S(t,void 0,function(t){return e._settledAt(ut,r,t)},function(t){return e._settledAt(ct,r,t)})},V.all=L,V.race=N,V.resolve=d,V.reject=B,V._setScheduler=i,V._setAsap=u,V._asap=Q,V.prototype={constructor:V,then:h,catch:function(t){return this.then(null,t)}},V.polyfill=$,V.Promise=V,V})}).call(r,e(148),e(51))},function(t,r){t.exports=function(){var t=function(t){return"function"==typeof t},r=function(t){var r=Number(t);return isNaN(r)?0:0!==r&&isFinite(r)?(r>0?1:-1)*Math.floor(Math.abs(r)):r},e=Math.pow(2,53)-1,n=function(t){var n=r(t);return Math.min(Math.max(n,0),e)},o=function(t){if(null!=t){if(["string","number","boolean","symbol"].indexOf(typeof t)>-1)return Symbol.iterator;if("undefined"!=typeof Symbol&&"iterator"in Symbol&&Symbol.iterator in t)return Symbol.iterator;if("@@iterator"in t)return"@@iterator"}},i=function(r,e){if(null!=r&&null!=e){var n=r[e];if(null==n)return;if(!t(n))throw new TypeError(n+" is not a function");return n}},u=function(t){var r=t.next();return!Boolean(r.done)&&r};return function(r){"use strict";var e,c=this,a=arguments.length>1?arguments[1]:void 0;if(void 0!==a){if(!t(a))throw new TypeError("Array.from: when provided, the second argument must be a function");arguments.length>2&&(e=arguments[2])}var s,f,l=i(r,o(r));if(void 0!==l){s=t(c)?Object(new c):[];var p=l.call(r);if(null==p)throw new TypeError("Array.from requires an array-like or iterable object");f=0;for(var v,h;;){if(!(v=u(p)))return s.length=f,s;h=v.value,s[f]=a?a.call(e,h,f):h,f++}}else{var d=Object(r);if(null==r)throw new TypeError("Array.from requires an array-like object - not null or undefined");var y=n(d.length);s=t(c)?Object(new c(y)):new Array(y),f=0;for(var _;f<y;)_=d[f],s[f]=a?a.call(e,_,f):_,f++;s.length=y}return s}}()},function(t,r,e){"use strict";function n(t){if(t&&t.__esModule)return t;var r={};if(null!=t)for(var e in t)Object.prototype.hasOwnProperty.call(t,e)&&(r[e]=t[e]);return r.default=t,r}function o(t){return t&&t.__esModule?t:{default:t}}function i(t){if(Array.isArray(t)){for(var r=0,e=Array(t.length);r<t.length;r++)e[r]=t[r];return e}return Array.from(t)}Object.defineProperty(r,"__esModule",{value:!0}),r.invokeApiFunction=r.getDescription=r.buildApiFromDescription=void 0;var u=e(7),c=o(u),a=e(19),s=e(142),f=o(s),l=e(59),p=n(l),v=e(18),h=e(29),d=o(h),y=!0,_=function(t,r,e){return function(){for(var n=arguments.length,o=Array(n),i=0;i<n;i++)o[i]=arguments[i];var u=p.serialize(o),s=u.args,f=u.transfer;return(0,a.send)({appId:t,call:e,args:s,intent:c.default.INVOKE_FUNCTION},r,f).then(d.default)}};r.buildApiFromDescription=function(t,r,e){return(0,f.default)(r,function(r,n){return _(t,e,n)})},r.getDescription=function(t){return(0,f.default)(t,function(){return y})},r.invokeApiFunction=function(t,r,e){try{var n=p.deserialize(r,e);return Promise.resolve(t.apply(void 0,i(n))).catch(v.serialize)}catch(t){return(0,v.serialize)(t)}}},function(t,r,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(r,"__esModule",{value:!0}),r.isEmpty=r.unregisterApp=r.hasApp=r.getAppData=r.getAppById=r.registerApp=void 0;var o=e(14),i=n(o),u=e(137),c=n(u),a={};r.registerApp=function(t,r,e){a[t]={app:r,onApiCall:e}},r.getAppById=function(t){return(0,i.default)(a,[t,"app"])},r.getAppData=function(t){return a[t]},r.hasApp=function(t){return Boolean(a[t])},r.unregisterApp=function(t){return delete a[t]},r.isEmpty=function(){return(0,c.default)(a)}},function(t,r,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t){if(Array.isArray(t)){for(var r=0,e=Array(t.length);r<t.length;r++)e[r]=t[r];return e}return Array.from(t)}Object.defineProperty(r,"__esModule",{value:!0}),r.deserialize=r.serialize=void 0;var i=function(){function t(t,r){var e=[],n=!0,o=!1,i=void 0;try{for(var u,c=t[Symbol.iterator]();!(n=(u=c.next()).done)&&(e.push(u.value),!r||e.length!==r);n=!0);}catch(t){o=!0,i=t}finally{try{!n&&c.return&&c.return()}finally{if(o)throw i}}return e}return function(r,e){if(Array.isArray(r))return r;if(Symbol.iterator in Object(r))return t(r,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),u=e(5),c=n(u),a=e(147),s=n(a),f=e(141),l=n(f),p=e(19),v=e(7),h=n(v),d=e(29),y=n(d);r.serialize=function(t){return(0,s.default)(t,function(t,r){var e=t.args,n=t.transfer;if((0,c.default)(r)){var u=new MessageChannel,a=u.port1,s=u.port2;a.onmessage=function(t){var e=t.data,n=i(t.ports,1),u=n[0],c=e.__port||u;Promise.resolve(r.apply(void 0,o(e))).then((0,p.sendResponse)(c,h.default.RESOLVE),(0,p.sendResponse)(c,h.default.REJECT))};var f=n.length;e.push({type:"function",index:f,port:s}),n.push(s)}else e.push({type:"value",value:r})},{args:[],transfer:[]})},r.deserialize=function(t,r){return(0,l.default)(t,function(t){switch(t.type){case"value":return t.value;case"function":return function(){for(var e=t.port||r[t.index],n=arguments.length,o=Array(n),i=0;i<n;i++)o[i]=arguments[i];return(0,p.send)(o,{target:e}).then(y.default)}}})}},function(t,r,e){"use strict";Object.defineProperty(r,"__esModule",{value:!0});var n=!1;r.addSingleHandler=function(t){n||(n=!0,self.addEventListener("message",t))},r.removeSingleHandler=function(t){self.removeEventListener("message",t),n=!1}},function(t,r,e){var n=e(3),o=e(1),i=n(o,"DataView");t.exports=i},function(t,r,e){function n(t){var r=-1,e=null==t?0:t.length;for(this.clear();++r<e;){var n=t[r];this.set(n[0],n[1])}}var o=e(103),i=e(104),u=e(105),c=e(106),a=e(107);n.prototype.clear=o,n.prototype.delete=i,n.prototype.get=u,n.prototype.has=c,n.prototype.set=a,t.exports=n},function(t,r,e){var n=e(3),o=e(1),i=n(o,"Promise");t.exports=i},function(t,r,e){var n=e(3),o=e(1),i=n(o,"Set");t.exports=i},function(t,r,e){function n(t){var r=-1,e=null==t?0:t.length;for(this.__data__=new o;++r<e;)this.add(t[r])}var o=e(21),i=e(126),u=e(127);n.prototype.add=n.prototype.push=i,n.prototype.has=u,t.exports=n},function(t,r,e){var n=e(1),o=n.Uint8Array;t.exports=o},function(t,r,e){var n=e(3),o=e(1),i=n(o,"WeakMap");t.exports=i},function(t,r){function e(t,r){for(var e=-1,n=null==t?0:t.length;++e<n&&!1!==r(t[e],e,t););return t}t.exports=e},function(t,r){function e(t,r){for(var e=-1,n=null==t?0:t.length,o=0,i=[];++e<n;){var u=t[e];r(u,e,t)&&(i[o++]=u)}return i}t.exports=e},function(t,r,e){function n(t,r){var e=u(t),n=!e&&i(t),f=!e&&!n&&c(t),p=!e&&!n&&!f&&s(t),v=e||n||f||p,h=v?o(t.length,String):[],d=h.length;for(var y in t)!r&&!l.call(t,y)||v&&("length"==y||f&&("offset"==y||"parent"==y)||p&&("buffer"==y||"byteLength"==y||"byteOffset"==y)||a(y,d))||h.push(y);return h}var o=e(88),i=e(25),u=e(0),c=e(16),a=e(43),s=e(17),f=Object.prototype,l=f.hasOwnProperty;t.exports=n},function(t,r){function e(t,r){for(var e=-1,n=r.length,o=t.length;++e<n;)t[o+e]=r[e];return t}t.exports=e},function(t,r){function e(t,r){for(var e=-1,n=null==t?0:t.length;++e<n;)if(r(t[e],e,t))return!0;return!1}t.exports=e},function(t,r,e){function n(t,r,e){"__proto__"==r&&o?o(t,r,{configurable:!0,enumerable:!0,value:e,writable:!0}):t[r]=e}var o=e(94);t.exports=n},function(t,r,e){var n=e(6),o=Object.create,i=function(){function t(){}return function(r){if(!n(r))return{};if(o)return o(r);t.prototype=r;var e=new t;return t.prototype=void 0,e}}();t.exports=i},function(t,r,e){var n=e(22),o=e(92),i=o(n);t.exports=i},function(t,r,e){var n=e(93),o=n();t.exports=o},function(t,r,e){function n(t,r,e){var n=r(t);return i(t)?n:o(n,e(t))}var o=e(71),i=e(0);t.exports=n},function(t,r){function e(t,r){return null!=t&&r in Object(t)}t.exports=e},function(t,r,e){function n(t){return i(t)&&o(t)==u}var o=e(2),i=e(4),u="[object Arguments]";t.exports=n},function(t,r,e){function n(t,r,e,n,y,b){var g=s(t),x=s(r),j=g?h:a(t),m=x?h:a(r);j=j==v?d:j,m=m==v?d:m;var w=j==d,O=m==d,A=j==m;if(A&&f(t)){if(!f(r))return!1;g=!0,w=!1}if(A&&!w)return b||(b=new o),g||l(t)?i(t,r,e,n,y,b):u(t,r,j,e,n,y,b);if(!(e&p)){var E=w&&_.call(t,"__wrapped__"),P=O&&_.call(r,"__wrapped__");if(E||P){var S=E?t.value():t,T=P?r.value():r;return b||(b=new o),y(S,T,e,n,b)}}return!!A&&(b||(b=new o),c(t,r,e,n,y,b))}var o=e(31),i=e(39),u=e(95),c=e(96),a=e(42),s=e(0),f=e(16),l=e(17),p=1,v="[object Arguments]",h="[object Array]",d="[object Object]",y=Object.prototype,_=y.hasOwnProperty;t.exports=n},function(t,r,e){function n(t,r,e,n){var a=e.length,s=a,f=!n;if(null==t)return!s;for(t=Object(t);a--;){var l=e[a];if(f&&l[2]?l[1]!==t[l[0]]:!(l[0]in t))return!1}for(;++a<s;){l=e[a];var p=l[0],v=t[p],h=l[1];if(f&&l[2]){if(void 0===v&&!(p in t))return!1}else{var d=new o;if(n)var y=n(v,h,p,t,r,d);if(!(void 0===y?i(h,v,u|c,n,d):y))return!1}}return!0}var o=e(31),i=e(34),u=1,c=2;t.exports=n},function(t,r,e){function n(t){return u(t)&&i(t.length)&&!!c[o(t)]}var o=e(2),i=e(26),u=e(4),c={};c["[object Float32Array]"]=c["[object Float64Array]"]=c["[object Int8Array]"]=c["[object Int16Array]"]=c["[object Int32Array]"]=c["[object Uint8Array]"]=c["[object Uint8ClampedArray]"]=c["[object Uint16Array]"]=c["[object Uint32Array]"]=!0,c["[object Arguments]"]=c["[object Array]"]=c["[object ArrayBuffer]"]=c["[object Boolean]"]=c["[object DataView]"]=c["[object Date]"]=c["[object Error]"]=c["[object Function]"]=c["[object Map]"]=c["[object Number]"]=c["[object Object]"]=c["[object RegExp]"]=c["[object Set]"]=c["[object String]"]=c["[object WeakMap]"]=!1,t.exports=n},function(t,r,e){function n(t,r){var e=-1,n=i(t)?Array(t.length):[];return o(t,function(t,o,i){n[++e]=r(t,o,i)}),n}var o=e(75),i=e(15);t.exports=n},function(t,r,e){function n(t){var r=i(t);return 1==r.length&&r[0][2]?u(r[0][0],r[0][1]):function(e){return e===t||o(e,t,r)}}var o=e(81),i=e(98),u=e(46);t.exports=n},function(t,r,e){function n(t,r){return c(t)&&a(r)?s(f(t),r):function(e){var n=i(e,t);return void 0===n&&n===r?u(e,t):o(r,n,l|p)}}var o=e(34),i=e(14),u=e(135),c=e(24),a=e(45),s=e(46),f=e(13),l=1,p=2;t.exports=n},function(t,r){function e(t){return function(r){return null==r?void 0:r[t]}}t.exports=e},function(t,r,e){function n(t){return function(r){return o(r,t)}}var o=e(33);t.exports=n},function(t,r){function e(t,r){for(var e=-1,n=Array(t);++e<t;)n[e]=r(e);return n}t.exports=e},function(t,r,e){function n(t){if("string"==typeof t)return t;if(u(t))return i(t,n)+"";if(c(t))return f?f.call(t):"";var r=t+"";return"0"==r&&1/t==-a?"-0":r}var o=e(9),i=e(32),u=e(0),c=e(27),a=1/0,s=o?o.prototype:void 0,f=s?s.toString:void 0;t.exports=n},function(t,r){function e(t){return function(r){return t(r)}}t.exports=e},function(t,r){function e(t,r){return t.has(r)}t.exports=e},function(t,r,e){function n(t,r){return function(e,n){if(null==e)return e;if(!o(e))return t(e,n);for(var i=e.length,u=r?i:-1,c=Object(e);(r?u--:++u<i)&&!1!==n(c[u],u,c););return e}}var o=e(15);t.exports=n},function(t,r){function e(t){return function(r,e,n){for(var o=-1,i=Object(r),u=n(r),c=u.length;c--;){var a=u[t?c:++o];if(!1===e(i[a],a,i))break}return r}}t.exports=e},function(t,r,e){var n=e(3),o=function(){try{var t=n(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,r,e){function n(t,r,e,n,o,w,A){switch(e){case m:if(t.byteLength!=r.byteLength||t.byteOffset!=r.byteOffset)return!1;t=t.buffer,r=r.buffer;case j:return!(t.byteLength!=r.byteLength||!w(new i(t),new i(r)));case p:case v:case y:return u(+t,+r);case h:return t.name==r.name&&t.message==r.message;case _:case g:return t==r+"";case d:var E=a;case b:var P=n&f;if(E||(E=s),t.size!=r.size&&!P)return!1;var S=A.get(t);if(S)return S==r;n|=l,A.set(t,r);var T=c(E(t),E(r),n,o,w,A);return A.delete(t),T;case x:if(O)return O.call(t)==O.call(r)}return!1}var o=e(9),i=e(66),u=e(49),c=e(39),a=e(121),s=e(128),f=1,l=2,p="[object Boolean]",v="[object Date]",h="[object Error]",d="[object Map]",y="[object Number]",_="[object RegExp]",b="[object Set]",g="[object String]",x="[object Symbol]",j="[object ArrayBuffer]",m="[object DataView]",w=o?o.prototype:void 0,O=w?w.valueOf:void 0;t.exports=n},function(t,r,e){function n(t,r,e,n,u,a){var s=e&i,f=o(t),l=f.length;if(l!=o(r).length&&!s)return!1;for(var p=l;p--;){var v=f[p];if(!(s?v in r:c.call(r,v)))return!1}var h=a.get(t);if(h&&a.get(r))return h==r;var d=!0;a.set(t,r),a.set(r,t);for(var y=s;++p<l;){v=f[p];var _=t[v],b=r[v];if(n)var g=s?n(b,_,v,r,t,a):n(_,b,v,t,r,a);if(!(void 0===g?_===b||u(_,b,e,n,a):g)){d=!1;break}y||(y="constructor"==v)}if(d&&!y){var x=t.constructor,j=r.constructor;x!=j&&"constructor"in t&&"constructor"in r&&!("function"==typeof x&&x instanceof x&&"function"==typeof j&&j instanceof j)&&(d=!1)}return a.delete(t),a.delete(r),d}var o=e(97),i=1,u=Object.prototype,c=u.hasOwnProperty;t.exports=n},function(t,r,e){function n(t){return o(t,u,i)}var o=e(77),i=e(100),u=e(28);t.exports=n},function(t,r,e){function n(t){for(var r=i(t),e=r.length;e--;){var n=r[e],u=t[n];r[e]=[n,u,o(u)]}return r}var o=e(45),i=e(28);t.exports=n},function(t,r,e){function n(t){var r=u.call(t,a),e=t[a];try{t[a]=void 0;var n=!0}catch(t){}var o=c.call(t);return n&&(r?t[a]=e:delete t[a]),o}var o=e(9),i=Object.prototype,u=i.hasOwnProperty,c=i.toString,a=o?o.toStringTag:void 0;t.exports=n},function(t,r,e){var n=e(69),o=e(145),i=Object.prototype,u=i.propertyIsEnumerable,c=Object.getOwnPropertySymbols,a=c?function(t){return null==t?[]:(t=Object(t),n(c(t),function(r){return u.call(t,r)}))}:o;t.exports=a},function(t,r){function e(t,r){return null==t?void 0:t[r]}t.exports=e},function(t,r,e){function n(t,r,e){r=o(r,t);for(var n=-1,f=r.length,l=!1;++n<f;){var p=s(r[n]);if(!(l=null!=t&&e(t,p)))break;t=t[p]}return l||++n!=f?l:!!(f=null==t?0:t.length)&&a(f)&&c(p,f)&&(u(t)||i(t))}var o=e(37),i=e(25),u=e(0),c=e(43),a=e(26),s=e(13);t.exports=n},function(t,r,e){function n(){this.__data__=o?o(null):{},this.size=0}var o=e(12);t.exports=n},function(t,r){function e(t){var r=this.has(t)&&delete this.__data__[t];return this.size-=r?1:0,r}t.exports=e},function(t,r,e){function n(t){var r=this.__data__;if(o){var e=r[t];return e===i?void 0:e}return c.call(r,t)?r[t]:void 0}var o=e(12),i="__lodash_hash_undefined__",u=Object.prototype,c=u.hasOwnProperty;t.exports=n},function(t,r,e){function n(t){var r=this.__data__;return o?void 0!==r[t]:u.call(r,t)}var o=e(12),i=Object.prototype,u=i.hasOwnProperty;t.exports=n},function(t,r,e){function n(t,r){var e=this.__data__;return this.size+=this.has(t)?0:1,e[t]=o&&void 0===r?i:r,this}var o=e(12),i="__lodash_hash_undefined__";t.exports=n},function(t,r){function e(t){var r=typeof t;return"string"==r||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==t:null===t}t.exports=e},function(t,r,e){var n=e(38),o=e(5),i=e(50),u=n?o:i;t.exports=u},function(t,r,e){function n(t){return!!i&&i in t}var o=e(38),i=function(){var t=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=n},function(t,r){function e(){this.__data__=[],this.size=0}t.exports=e},function(t,r,e){function n(t){var r=this.__data__,e=o(r,t);return!(e<0)&&(e==r.length-1?r.pop():u.call(r,e,1),--this.size,!0)}var o=e(10),i=Array.prototype,u=i.splice;t.exports=n},function(t,r,e){function n(t){var r=this.__data__,e=o(r,t);return e<0?void 0:r[e][1]}var o=e(10);t.exports=n},function(t,r,e){function n(t){return o(this.__data__,t)>-1}var o=e(10);t.exports=n},function(t,r,e){function n(t,r){var e=this.__data__,n=o(e,t);return n<0?(++this.size,e.push([t,r])):e[n][1]=r,this}var o=e(10);t.exports=n},function(t,r,e){function n(){this.size=0,this.__data__={hash:new o,map:new(u||i),string:new o}}var o=e(62),i=e(8),u=e(20);t.exports=n},function(t,r,e){function n(t){var r=o(this,t).delete(t);return this.size-=r?1:0,r}var o=e(11);t.exports=n},function(t,r,e){function n(t){return o(this,t).get(t)}var o=e(11);t.exports=n},function(t,r,e){function n(t){return o(this,t).has(t)}var o=e(11);t.exports=n},function(t,r,e){function n(t,r){var e=o(this,t),n=e.size;return e.set(t,r),this.size+=e.size==n?0:1,this}var o=e(11);t.exports=n},function(t,r){function e(t){var r=-1,e=Array(t.size);return t.forEach(function(t,n){e[++r]=[n,t]}),e}t.exports=e},function(t,r,e){function n(t){var r=o(t,function(t){return e.size===i&&e.clear(),t}),e=r.cache;return r}var o=e(143),i=500;t.exports=n},function(t,r,e){var n=e(47),o=n(Object.keys,Object);t.exports=o},function(t,r,e){(function(t){var n=e(40),o="object"==typeof r&&r&&!r.nodeType&&r,i=o&&"object"==typeof t&&t&&!t.nodeType&&t,u=i&&i.exports===o,c=u&&n.process,a=function(){try{return c&&c.binding&&c.binding("util")}catch(t){}}();t.exports=a}).call(r,e(52)(t))},function(t,r){function e(t){return o.call(t)}var n=Object.prototype,o=n.toString;t.exports=e},function(t,r){function e(t){return this.__data__.set(t,n),this}var n="__lodash_hash_undefined__";t.exports=e},function(t,r){function e(t){return this.__data__.has(t)}t.exports=e},function(t,r){function e(t){var r=-1,e=Array(t.size);return t.forEach(function(t){e[++r]=t}),e}t.exports=e},function(t,r,e){function n(){this.__data__=new o,this.size=0}var o=e(8);t.exports=n},function(t,r){function e(t){var r=this.__data__,e=r.delete(t);return this.size=r.size,e}t.exports=e},function(t,r){function e(t){return this.__data__.get(t)}t.exports=e},function(t,r){function e(t){return this.__data__.has(t)}t.exports=e},function(t,r,e){function n(t,r){var e=this.__data__;if(e instanceof o){var n=e.__data__;if(!i||n.length<c-1)return n.push([t,r]),this.size=++e.size,this;e=this.__data__=new u(n)}return e.set(t,r),this.size=e.size,this}var o=e(8),i=e(20),u=e(21),c=200;t.exports=n},function(t,r,e){var n=e(122),o=/^\./,i=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,u=/\\(\\)?/g,c=n(function(t){var r=[];return o.test(t)&&r.push(""),t.replace(i,function(t,e,n,o){r.push(n?o.replace(u,"$1"):e||t)}),r});t.exports=c},function(t,r,e){function n(t,r){return null!=t&&i(t,r,o)}var o=e(78),i=e(102);t.exports=n},function(t,r){function e(t){return t}t.exports=e},function(t,r,e){function n(t){if(null==t)return!0;if(a(t)&&(c(t)||"string"==typeof t||"function"==typeof t.splice||s(t)||l(t)||u(t)))return!t.length;var r=i(t);if(r==p||r==v)return!t.size;if(f(t))return!o(t).length;for(var e in t)if(d.call(t,e))return!1;return!0}var o=e(36),i=e(42),u=e(25),c=e(0),a=e(15),s=e(16),f=e(44),l=e(17),p="[object Map]",v="[object Set]",h=Object.prototype,d=h.hasOwnProperty;t.exports=n},function(t,r,e){function n(t){if(!i(t))return!1;var r=o(t);return r==a||r==c||"string"==typeof t.message&&"string"==typeof t.name&&!u(t)}var o=e(2),i=e(4),u=e(140),c="[object DOMException]",a="[object Error]";t.exports=n},function(t,r,e){function n(t){if(i(t))throw new Error(u);return o(t)}var o=e(35),i=e(109),u="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.";t.exports=n},function(t,r,e){function n(t){if(!u(t)||o(t)!=c)return!1;var r=i(t);if(null===r)return!0;var e=l.call(r,"constructor")&&r.constructor;return"function"==typeof e&&e instanceof e&&f.call(e)==p}var o=e(2),i=e(41),u=e(4),c="[object Object]",a=Function.prototype,s=Object.prototype,f=a.toString,l=s.hasOwnProperty,p=f.call(Object);t.exports=n},function(t,r,e){function n(t,r){return(c(t)?o:u)(t,i(r,3))}var o=e(32),i=e(23),u=e(83),c=e(0);t.exports=n},function(t,r,e){function n(t,r){var e={};return r=u(r,3),i(t,function(t,n,i){o(e,n,r(t,n,i))}),e}var o=e(73),i=e(22),u=e(23);t.exports=n},function(t,r,e){function n(t,r){if("function"!=typeof t||null!=r&&"function"!=typeof r)throw new TypeError(i);var e=function(){var n=arguments,o=r?r.apply(this,n):n[0],i=e.cache;if(i.has(o))return i.get(o);var u=t.apply(this,n);return e.cache=i.set(o,u)||i,u};return e.cache=new(n.Cache||o),e}var o=e(21),i="Expected a function";n.Cache=o,t.exports=n},function(t,r,e){function n(t){return u(t)?o(c(t)):i(t)}var o=e(86),i=e(87),u=e(24),c=e(13);t.exports=n},function(t,r){function e(){return[]}t.exports=e},function(t,r,e){function n(t){return null==t?"":o(t)}var o=e(89);t.exports=n},function(t,r,e){function n(t,r,e){var n=s(t),h=n||f(t)||v(t);if(r=c(r,4),null==e){var d=t&&t.constructor;e=h?n?new d:[]:p(t)&&l(d)?i(a(t)):{}}return(h?o:u)(t,function(t,n,o){return r(e,t,n,o)}),e}var o=e(68),i=e(74),u=e(22),c=e(23),a=e(41),s=e(0),f=e(16),l=e(5),p=e(6),v=e(17);t.exports=n},function(t,r){function e(){throw new Error("setTimeout has not been defined")}function n(){throw new Error("clearTimeout has not been defined")}function o(t){if(f===setTimeout)return setTimeout(t,0);if((f===e||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(r){try{return f.call(null,t,0)}catch(r){return f.call(this,t,0)}}}function i(t){if(l===clearTimeout)return clearTimeout(t);if((l===n||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(t);try{return l(t)}catch(r){try{return l.call(null,t)}catch(r){return l.call(this,t)}}}function u(){d&&v&&(d=!1,v.length?h=v.concat(h):y=-1,h.length&&c())}function c(){if(!d){var t=o(u);d=!0;for(var r=h.length;r;){for(v=h,h=[];++y<r;)v&&v[y].run();y=-1,r=h.length}v=null,d=!1,i(t)}}function a(t,r){this.fun=t,this.array=r}function s(){}var f,l,p=t.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:e}catch(t){f=e}try{l="function"==typeof clearTimeout?clearTimeout:n}catch(t){l=n}}();var v,h=[],d=!1,y=-1;p.nextTick=function(t){var r=new Array(arguments.length-1);if(arguments.length>1)for(var e=1;e<arguments.length;e++)r[e-1]=arguments[e];h.push(new a(t,r)),1!==h.length||d||o(c)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=s,p.addListener=s,p.once=s,p.off=s,p.removeListener=s,p.removeAllListeners=s,p.emit=s,p.prependListener=s,p.prependOnceListener=s,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(t,r){},function(t,r,e){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}function o(t){if(t&&t.__esModule)return t;var r={};if(null!=t)for(var e in t)Object.prototype.hasOwnProperty.call(t,e)&&(r[e]=t[e]);return r.default=t,r}Object.defineProperty(r,"__esModule",{value:!0}),r.api=void 0;var i=e(54),u=o(i),c=e(55),a=n(c),s=e(53),f=n(s);Array.from||(Array.from=f.default),a.default.polyfill(),r.api=u}])});
//# sourceMappingURL=pm-rpc.min.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(8);
self.importScripts(constants.LODASH);
var MessageType = __webpack_require__(4);
var workerLogger = __webpack_require__(20);
var errors = __webpack_require__(2);
var workerUtils = __webpack_require__(1);
var bootstrapHandler = __webpack_require__(14);
var loadHandler = __webpack_require__(16);
var initHandler = __webpack_require__(15);
var startHandler = __webpack_require__(19);
var renderHandler = __webpack_require__(18);
var loadUserCodeHandler = __webpack_require__(17);
var UserCodeStore = __webpack_require__(13);
var AppsStore = __webpack_require__(12);
var scriptsHandler = __webpack_require__(9);

var _ = __webpack_require__(0);
var handleLoad = _.once(loadHandler.handleLoad);
var handleInit = _.once(initHandler.handleInit);
var handleStart = _.once(startHandler.handleStart);
var handleRendered = _.once(renderHandler.handle);
var updateWixCodeDataAfterLogin = loadHandler.updateWixCodeDataAfterLogin;
var handleScriptImport = scriptsHandler.handleScript;

var MAX_FETCH_DELAY = 500;

var devConsole = workerLogger.wrapConsole(console, self.postMessage);
var userCodeStore = new UserCodeStore();
var appsStore = new AppsStore();
var workerId = null;

self.onerror = function onError(message, filename, lineno, colno, err) {
  devConsole.error(err ? err : message);
  workerUtils.reportBI(errors.PLATFORM_LIFECYCLE_UNHANDLED_EXCEPTION, {
    errorMsg: message,
    stack: err && err.stack,
    line: lineno,
    column: colno
  });
};

var messages = [];
var fetchScriptsCount = 0;

self.onmessage = function (message) {
  if (!message.data) {
    return;
  }

  if (message.data.type === MessageType.SCRIPT_IMPORT_MESSAGE) {
    handleScriptImport(message.data);
    if (--fetchScriptsCount === 0) {
      flushMessages();
      return;
    }
  }

  messages.push(message);
  if (message.data.type === MessageType.BOOTSTRAP) {
    if (message.data.fetchScriptsCount) {
      fetchScriptsCount = message.data.fetchScriptsCount;
      setTimeout(flushMessages, MAX_FETCH_DELAY);
    } else {
      flushMessages();
    }
  }
};

function flushMessages() {
  if (messages) {
    self.onmessage = processMessage;
    messages.forEach(processMessage);
    messages = null;
  }
}

function processMessage(message) {
  if (!message.data) {
    return;
  }

  switch (message.data.type) {
    case MessageType.BOOTSTRAP:
      bootstrapHandler.handleBootstrap(message.data, appsStore);
      break;
    case MessageType.LOAD_USER_CODE:
      loadUserCodeHandler.handleLoadUserCode(message.data, { userCodeStore: userCodeStore });
      break;
    case MessageType.LOAD:
      workerId = message.data.workerId;
      handleLoad(message.data, {
        workerId: workerId,
        getApp: appsStore.get.bind(appsStore),
        userCodeStore: userCodeStore
      });
      break;
    case MessageType.INIT:
      handleInit(message.data, {
        workerId: workerId,
        getApp: appsStore.get.bind(appsStore)
      });
      break;
    case MessageType.START:
      handleStart(message.data, {
        workerId: workerId,
        getAllApps: appsStore.getAll.bind(appsStore)
      });
      break;
    case MessageType.PAGE_RENDERED:
      handleRendered(message.data);
      break;
    case MessageType.UPDATE_WIX_CODE_DATA_AFTER_LOGIN:
      updateWixCodeDataAfterLogin(message.data);
      break;
    case MessageType.SCRIPT_IMPORT_MESSAGE:
      break;
    default:
      delegateMessageToSDK(message);
      break;
  }
}

function delegateMessageToSDK(message) {
  if (self.wix) {
    self.wix.__INTERNAL__.onMessage(message);
  }
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// wixcode-worker.js